import { baseApi as api } from "./baseApi";
export const addTagTypes = [
  "Admin",
  "Users",
  "api",
  "Assessment Progress",
  "Assessments",
  "Assessments Comments",
  "Tasks",
  "Review Assignments",
  "Site Assessments",
  "Site Assessments Comments",
  "Comments",
  "Verifier Assignment",
  "Evidence Files",
  "Sites",
  "Reports",
  "Business Intelligence",
  "Corporations",
  "Files",
  "Notifications",
  "Machine Token",
  "Protocol Sets",
  "Protocols",
  "Scope of Applicability",
  "Requirements",
  "Standard Guidance",
  "Standards",
  "SubThemes",
  "Themes",
  "User Management",
  "User Profile",
  "WhoAmI",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: build => ({
      apiV1AdminMappingJobsDownloadRetrieve: build.mutation<
        ApiV1AdminMappingJobsDownloadRetrieveApiResponse,
        ApiV1AdminMappingJobsDownloadRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/admin/mapping-jobs/${queryArg.id}/download/`, method: "GET" }),
        invalidatesTags: ["Admin"],
      }),
      apiV1AdminMappingJobsProgressRetrieve: build.query<
        ApiV1AdminMappingJobsProgressRetrieveApiResponse,
        ApiV1AdminMappingJobsProgressRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/admin/mapping-jobs/${queryArg.id}/progress/` }),
        providesTags: ["Admin"],
      }),
      apiV1AdminMappingJobsDumpCreate: build.mutation<
        ApiV1AdminMappingJobsDumpCreateApiResponse,
        ApiV1AdminMappingJobsDumpCreateApiArg
      >({
        query: () => ({ url: `/api/v1/admin/mapping-jobs/dump/`, method: "POST" }),
        invalidatesTags: ["Admin"],
      }),
      apiV1AdminMappingJobsLoadCreate: build.mutation<
        ApiV1AdminMappingJobsLoadCreateApiResponse,
        ApiV1AdminMappingJobsLoadCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/admin/mapping-jobs/load/`, method: "POST", body: queryArg.body }),
        invalidatesTags: ["Admin"],
      }),
      apiV1AdminUserReportRetrieve: build.mutation<
        ApiV1AdminUserReportRetrieveApiResponse,
        ApiV1AdminUserReportRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/admin/user-report/${queryArg.tenantId}/`,
          method: "GET",
          params: {
            exclude_erm: queryArg.excludeErm,
            excluded_groups: queryArg.excludedGroups,
            group: queryArg.group,
          },
        }),
        invalidatesTags: ["Users"],
      }),
      apiV1AssessmentsCleanupDestroy: build.mutation<
        ApiV1AssessmentsCleanupDestroyApiResponse,
        ApiV1AssessmentsCleanupDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/${queryArg.assessmentId}/cleanup/`,
          method: "DELETE",
        }),
        invalidatesTags: ["api"],
      }),
      apiV1AssessmentsThemeProgressList: build.query<
        ApiV1AssessmentsThemeProgressListApiResponse,
        ApiV1AssessmentsThemeProgressListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/${queryArg.assessmentId}/theme_progress/`,
          params: {
            site_assessment_id: queryArg.siteAssessmentId,
          },
        }),
        providesTags: ["Assessment Progress"],
      }),
      apiV1AssessmentsAssessmentsList: build.query<
        ApiV1AssessmentsAssessmentsListApiResponse,
        ApiV1AssessmentsAssessmentsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/`,
          params: {
            active: queryArg.active,
            completed: queryArg.completed,
            favorite: queryArg.favorite,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
          },
        }),
        providesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsCreate: build.mutation<
        ApiV1AssessmentsAssessmentsCreateApiResponse,
        ApiV1AssessmentsAssessmentsCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/`,
          method: "POST",
          body: queryArg.assessmentCreateRequest,
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsRetrieve: build.query<
        ApiV1AssessmentsAssessmentsRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/` }),
        providesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsUpdate: build.mutation<
        ApiV1AssessmentsAssessmentsUpdateApiResponse,
        ApiV1AssessmentsAssessmentsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/`,
          method: "PUT",
          body: queryArg.assessmentRequest,
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsPartialUpdate: build.mutation<
        ApiV1AssessmentsAssessmentsPartialUpdateApiResponse,
        ApiV1AssessmentsAssessmentsPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/`,
          method: "PATCH",
          body: queryArg.patchedAssessmentPartialUpdate,
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsDestroy: build.mutation<
        ApiV1AssessmentsAssessmentsDestroyApiResponse,
        ApiV1AssessmentsAssessmentsDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsCommentsList: build.query<
        ApiV1AssessmentsAssessmentsCommentsListApiResponse,
        ApiV1AssessmentsAssessmentsCommentsListApiArg
      >({
        query: queryArg => ({ url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/comments/` }),
        providesTags: ["Assessments Comments"],
      }),
      apiV1AssessmentsAssessmentsCompleteCreate: build.mutation<
        ApiV1AssessmentsAssessmentsCompleteCreateApiResponse,
        ApiV1AssessmentsAssessmentsCompleteCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/complete/`,
          method: "POST",
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsFavoriteCreate: build.mutation<
        ApiV1AssessmentsAssessmentsFavoriteCreateApiResponse,
        ApiV1AssessmentsAssessmentsFavoriteCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/favorite/`,
          method: "POST",
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsFavoriteDestroy: build.mutation<
        ApiV1AssessmentsAssessmentsFavoriteDestroyApiResponse,
        ApiV1AssessmentsAssessmentsFavoriteDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/favorite/`,
          method: "DELETE",
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsProtocolQuestionsList: build.query<
        ApiV1AssessmentsAssessmentsProtocolQuestionsListApiResponse,
        ApiV1AssessmentsAssessmentsProtocolQuestionsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/protocol_questions`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsProtocolQuestionsTasksList: build.query<
        ApiV1AssessmentsAssessmentsProtocolQuestionsTasksListApiResponse,
        ApiV1AssessmentsAssessmentsProtocolQuestionsTasksListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/protocol_questions/${queryArg.protocolQuestionId}/tasks`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentRetrieve: build.query<
        ApiV1AssessmentsAssessmentsReviewAssignmentRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignment/`,
        }),
        providesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsCreate: build.mutation<
        ApiV1AssessmentsAssessmentsReviewAssignmentsCreateApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments`,
          method: "POST",
          body: queryArg.reviewAssignmentCreateUpdate,
        }),
        invalidatesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsRetrieve: build.query<
        ApiV1AssessmentsAssessmentsReviewAssignmentsRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/${queryArg.assignmentId}`,
        }),
        providesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsUpdate: build.mutation<
        ApiV1AssessmentsAssessmentsReviewAssignmentsUpdateApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/${queryArg.assignmentId}`,
          method: "PUT",
          body: queryArg.reviewAssignmentCreateUpdate,
        }),
        invalidatesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsDestroy: build.mutation<
        ApiV1AssessmentsAssessmentsReviewAssignmentsDestroyApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/${queryArg.assignmentId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsAvailableStepsRetrieve: build.query<
        ApiV1AssessmentsAssessmentsReviewAssignmentsAvailableStepsRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsAvailableStepsRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/available_steps/`,
          params: {
            themes_group_id: queryArg.themesGroupId,
          },
        }),
        providesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsReviewersRetrieve: build.query<
        ApiV1AssessmentsAssessmentsReviewAssignmentsReviewersRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsReviewersRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/reviewers`,
        }),
        providesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsStepsList: build.query<
        ApiV1AssessmentsAssessmentsReviewAssignmentsStepsListApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsStepsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/steps`,
        }),
        providesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsStepsAssignedThemesList: build.query<
        ApiV1AssessmentsAssessmentsReviewAssignmentsStepsAssignedThemesListApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsStepsAssignedThemesListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/steps/${queryArg.stepId}/assigned_themes`,
        }),
        providesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsReviewAssignmentsStepsUnassignedThemesList: build.query<
        ApiV1AssessmentsAssessmentsReviewAssignmentsStepsUnassignedThemesListApiResponse,
        ApiV1AssessmentsAssessmentsReviewAssignmentsStepsUnassignedThemesListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/review_assignments/steps/${queryArg.stepId}/unassigned_themes`,
        }),
        providesTags: ["Review Assignments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsList: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsListApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments`,
          params: {
            site_id: queryArg.siteId,
          },
        }),
        providesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsRetrieve: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}`,
        }),
        providesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsApprovalRetrieve: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}/approval`,
        }),
        providesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}/approval`,
          method: "POST",
          body: queryArg.siteAssessmentApprovalCreate,
        }),
        invalidatesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsAssignCreate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsAssignCreateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsAssignCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}/assign`,
          method: "POST",
          body: queryArg.assignThemes,
        }),
        invalidatesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsAssignedRetrieve: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsAssignedRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsAssignedRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}/assigned`,
          params: {
            site_id: queryArg.siteId,
          },
        }),
        providesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsCommentsList: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsCommentsListApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsCommentsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}/comments`,
        }),
        providesTags: ["Site Assessments Comments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsVerificationRetrieve: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}/verification`,
        }),
        providesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsVerificationCreate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationCreateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.id}/verification`,
          method: "POST",
          body: queryArg.siteAssessmentVerificationCreate,
        }),
        invalidatesTags: ["Site Assessments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksList: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksListApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksRetrieve: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsList: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsListApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/comments`,
        }),
        providesTags: ["Comments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsCreate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsCreateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/comments`,
          method: "POST",
          body: queryArg.commentWithLink,
        }),
        invalidatesTags: ["Comments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsUpdate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsUpdateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/comments/${queryArg.commentId}`,
          method: "PUT",
          body: queryArg.commentWithLink,
        }),
        invalidatesTags: ["Comments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsDestroy: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsDestroyApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/comments/${queryArg.commentId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Comments"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksEvidencesUpdate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksEvidencesUpdateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksEvidencesUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/evidences`,
          method: "PUT",
          body: queryArg.body,
        }),
        invalidatesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksRelatedUsersRetrieve: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRelatedUsersRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRelatedUsersRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/related_users`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromOtherSitesList: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromOtherSitesListApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromOtherSitesListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/responses_from_other_sites`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromRelatedQuestionsList: build.query<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromRelatedQuestionsListApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromRelatedQuestionsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/responses_from_related_questions`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksReviewCreate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksReviewCreateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksReviewCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/review`,
          method: "POST",
          body: queryArg.review,
        }),
        invalidatesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSiteAssessmentsTasksSavePublishedChangesCreate: build.mutation<
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksSavePublishedChangesCreateApiResponse,
        ApiV1AssessmentsAssessmentsSiteAssessmentsTasksSavePublishedChangesCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/tasks/${queryArg.id}/save_published_changes`,
          method: "POST",
          body: queryArg.answer,
        }),
        invalidatesTags: ["Tasks"],
      }),
      apiV1AssessmentsAssessmentsSitesWithStandardsList: build.query<
        ApiV1AssessmentsAssessmentsSitesWithStandardsListApiResponse,
        ApiV1AssessmentsAssessmentsSitesWithStandardsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/sites_with_standards/`,
        }),
        providesTags: ["Assessments"],
      }),
      apiV1AssessmentsAssessmentsVerifierAssignmentsUpdate: build.mutation<
        ApiV1AssessmentsAssessmentsVerifierAssignmentsUpdateApiResponse,
        ApiV1AssessmentsAssessmentsVerifierAssignmentsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/verifier_assignments`,
          method: "PUT",
          body: queryArg.assignVerifiers,
        }),
        invalidatesTags: ["Verifier Assignment"],
      }),
      apiV1AssessmentsAssessmentsVerifierAssignmentsDeleteStepDestroy: build.mutation<
        ApiV1AssessmentsAssessmentsVerifierAssignmentsDeleteStepDestroyApiResponse,
        ApiV1AssessmentsAssessmentsVerifierAssignmentsDeleteStepDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/verifier_assignments/delete_step`,
          method: "DELETE",
        }),
        invalidatesTags: ["Verifier Assignment"],
      }),
      apiV1AssessmentsAssessmentsVerifierAssignmentsStepDetailsRetrieve: build.query<
        ApiV1AssessmentsAssessmentsVerifierAssignmentsStepDetailsRetrieveApiResponse,
        ApiV1AssessmentsAssessmentsVerifierAssignmentsStepDetailsRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/verifier_assignments/step_details`,
        }),
        providesTags: ["Verifier Assignment"],
      }),
      apiV1AssessmentsAssessmentsVerifierAssignmentsVerifiersList: build.query<
        ApiV1AssessmentsAssessmentsVerifierAssignmentsVerifiersListApiResponse,
        ApiV1AssessmentsAssessmentsVerifierAssignmentsVerifiersListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/assessments/${queryArg.assessmentId}/verifier_assignments/verifiers`,
        }),
        providesTags: ["Verifier Assignment"],
      }),
      apiV1AssessmentsEvidencesList: build.query<
        ApiV1AssessmentsEvidencesListApiResponse,
        ApiV1AssessmentsEvidencesListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/evidences/`,
          params: {
            page: queryArg.page,
            page_size: queryArg.pageSize,
            q: queryArg.q,
          },
        }),
        providesTags: ["Evidence Files"],
      }),
      apiV1AssessmentsSiteAssessmentsAvailableStandardsList: build.query<
        ApiV1AssessmentsSiteAssessmentsAvailableStandardsListApiResponse,
        ApiV1AssessmentsSiteAssessmentsAvailableStandardsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/site_assessments/${queryArg.siteAssessmentId}/available_standards`,
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsSiteAssessmentsAvailableTasksList: build.query<
        ApiV1AssessmentsSiteAssessmentsAvailableTasksListApiResponse,
        ApiV1AssessmentsSiteAssessmentsAvailableTasksListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/site_assessments/${queryArg.siteAssessmentId}/available_tasks`,
          params: {
            status: queryArg.status,
          },
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsSiteAssessmentsAvailableTasksStandardList: build.query<
        ApiV1AssessmentsSiteAssessmentsAvailableTasksStandardListApiResponse,
        ApiV1AssessmentsSiteAssessmentsAvailableTasksStandardListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/site_assessments/${queryArg.siteAssessmentId}/available_tasks/standard/${queryArg.standardId}`,
          params: {
            status: queryArg.status,
          },
        }),
        providesTags: ["Tasks"],
      }),
      apiV1AssessmentsSitesList: build.query<ApiV1AssessmentsSitesListApiResponse, ApiV1AssessmentsSitesListApiArg>({
        query: queryArg => ({
          url: `/api/v1/assessments/sites/`,
          params: {
            coordinator: queryArg.coordinator,
            country: queryArg.country,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            type: queryArg["type"],
          },
        }),
        providesTags: ["Sites"],
      }),
      apiV1AssessmentsSitesCreate: build.mutation<
        ApiV1AssessmentsSitesCreateApiResponse,
        ApiV1AssessmentsSitesCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/assessments/sites/`, method: "POST", body: queryArg.writeSite }),
        invalidatesTags: ["Sites"],
      }),
      apiV1AssessmentsSitesRetrieve: build.query<
        ApiV1AssessmentsSitesRetrieveApiResponse,
        ApiV1AssessmentsSitesRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/assessments/sites/${queryArg.id}/` }),
        providesTags: ["Sites"],
      }),
      apiV1AssessmentsSitesUpdate: build.mutation<
        ApiV1AssessmentsSitesUpdateApiResponse,
        ApiV1AssessmentsSitesUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/sites/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.writeSite,
        }),
        invalidatesTags: ["Sites"],
      }),
      apiV1AssessmentsSitesDestroy: build.mutation<
        ApiV1AssessmentsSitesDestroyApiResponse,
        ApiV1AssessmentsSitesDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/assessments/sites/${queryArg.id}/`, method: "DELETE" }),
        invalidatesTags: ["Sites"],
      }),
      apiV1AssessmentsSitesAllList: build.query<
        ApiV1AssessmentsSitesAllListApiResponse,
        ApiV1AssessmentsSitesAllListApiArg
      >({
        query: () => ({ url: `/api/v1/assessments/sites/all/` }),
        providesTags: ["Sites"],
      }),
      apiV1AssessmentsSitesAssignedAssessmentsWithStandardsList: build.query<
        ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsListApiResponse,
        ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/sites/assigned_assessments_with_standards`,
          params: {
            assessment_status: queryArg.assessmentStatus,
            assessments: queryArg.assessments,
            search: queryArg.search,
            sites: queryArg.sites,
            standards: queryArg.standards,
          },
        }),
        providesTags: ["Reports"],
      }),
      apiV1AssessmentsSitesAssignedAssessmentsWithStandardsFiltersRetrieve: build.query<
        ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsFiltersRetrieveApiResponse,
        ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsFiltersRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1/assessments/sites/assigned_assessments_with_standards/filters` }),
        providesTags: ["Reports"],
      }),
      apiV1AssessmentsSitesFiltersRetrieve: build.query<
        ApiV1AssessmentsSitesFiltersRetrieveApiResponse,
        ApiV1AssessmentsSitesFiltersRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1/assessments/sites/filters/` }),
        providesTags: ["Sites"],
      }),
      apiV1AssessmentsSitesImportCreate: build.mutation<
        ApiV1AssessmentsSitesImportCreateApiResponse,
        ApiV1AssessmentsSitesImportCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/sites/import/`,
          method: "POST",
          body: queryArg.importSites,
        }),
        invalidatesTags: ["Sites"],
      }),
      apiV1AssessmentsTasksProgressList: build.query<
        ApiV1AssessmentsTasksProgressListApiResponse,
        ApiV1AssessmentsTasksProgressListApiArg
      >({
        query: () => ({ url: `/api/v1/assessments/tasks_progress/` }),
        providesTags: ["Assessment Progress"],
      }),
      apiV1AssessmentsUpdatePanelAssessmentsRetrieve: build.query<
        ApiV1AssessmentsUpdatePanelAssessmentsRetrieveApiResponse,
        ApiV1AssessmentsUpdatePanelAssessmentsRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1/assessments/update_panel/assessments` }),
        providesTags: ["Assessments"],
      }),
      apiV1AssessmentsUpdatePanelAssessmentsDryRunRetrieve: build.mutation<
        ApiV1AssessmentsUpdatePanelAssessmentsDryRunRetrieveApiResponse,
        ApiV1AssessmentsUpdatePanelAssessmentsDryRunRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/update_panel/assessments/${queryArg.assessmentId}/dry_run`,
          method: "GET",
          params: {
            report_mode: queryArg.reportMode,
          },
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsUpdatePanelAssessmentsHistoryRetrieve: build.mutation<
        ApiV1AssessmentsUpdatePanelAssessmentsHistoryRetrieveApiResponse,
        ApiV1AssessmentsUpdatePanelAssessmentsHistoryRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/update_panel/assessments/${queryArg.assessmentId}/history/${queryArg.historyId}`,
          method: "GET",
          params: {
            report_mode: queryArg.reportMode,
          },
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1AssessmentsUpdatePanelAssessmentsUpdateCreate: build.mutation<
        ApiV1AssessmentsUpdatePanelAssessmentsUpdateCreateApiResponse,
        ApiV1AssessmentsUpdatePanelAssessmentsUpdateCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/assessments/update_panel/assessments/${queryArg.assessmentId}/update`,
          method: "POST",
        }),
        invalidatesTags: ["Assessments"],
      }),
      apiV1BiExportList: build.query<ApiV1BiExportListApiResponse, ApiV1BiExportListApiArg>({
        query: () => ({ url: `/api/v1/bi_export` }),
        providesTags: ["api"],
      }),
      apiV1ConformityHeatmapDataList: build.query<
        ApiV1ConformityHeatmapDataListApiResponse,
        ApiV1ConformityHeatmapDataListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/conformity-heatmap/data/`,
          params: {
            assessment: queryArg.assessment,
            site: queryArg.site,
            standard: queryArg.standard,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
            year: queryArg.year,
          },
        }),
        providesTags: ["Business Intelligence"],
      }),
      apiV1ConformityHeatmapFiltersDataRetrieve: build.query<
        ApiV1ConformityHeatmapFiltersDataRetrieveApiResponse,
        ApiV1ConformityHeatmapFiltersDataRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/conformity-heatmap/filters_data/`,
          params: {
            assessment: queryArg.assessment,
            site: queryArg.site,
            standard: queryArg.standard,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
            year: queryArg.year,
          },
        }),
        providesTags: ["Business Intelligence"],
      }),
      apiV1CorporationsList: build.query<ApiV1CorporationsListApiResponse, ApiV1CorporationsListApiArg>({
        query: () => ({ url: `/api/v1/corporations/` }),
        providesTags: ["Corporations"],
      }),
      apiV1CorporationsCreate: build.mutation<ApiV1CorporationsCreateApiResponse, ApiV1CorporationsCreateApiArg>({
        query: queryArg => ({ url: `/api/v1/corporations/`, method: "POST", body: queryArg.corporation }),
        invalidatesTags: ["Corporations"],
      }),
      apiV1CorporationsRetrieve: build.query<ApiV1CorporationsRetrieveApiResponse, ApiV1CorporationsRetrieveApiArg>({
        query: queryArg => ({ url: `/api/v1/corporations/${queryArg.id}/` }),
        providesTags: ["Corporations"],
      }),
      apiV1CorporationsUpdate: build.mutation<ApiV1CorporationsUpdateApiResponse, ApiV1CorporationsUpdateApiArg>({
        query: queryArg => ({
          url: `/api/v1/corporations/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.corporation,
        }),
        invalidatesTags: ["Corporations"],
      }),
      apiV1CorporationsCleanupDestroy: build.mutation<
        ApiV1CorporationsCleanupDestroyApiResponse,
        ApiV1CorporationsCleanupDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/corporations/${queryArg.id}/cleanup/`, method: "DELETE" }),
        invalidatesTags: ["api"],
      }),
      apiV1CorporationsFlagsRetrieve: build.query<
        ApiV1CorporationsFlagsRetrieveApiResponse,
        ApiV1CorporationsFlagsRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/corporations/${queryArg.id}/flags/` }),
        providesTags: ["Corporations"],
      }),
      apiV1CorporationsSimplifyList: build.query<
        ApiV1CorporationsSimplifyListApiResponse,
        ApiV1CorporationsSimplifyListApiArg
      >({
        query: () => ({ url: `/api/v1/corporations_simplify/` }),
        providesTags: ["Corporations"],
      }),
      apiV1DownloadRetrieve: build.mutation<ApiV1DownloadRetrieveApiResponse, ApiV1DownloadRetrieveApiArg>({
        query: queryArg => ({
          url: `/api/v1/download/`,
          method: "GET",
          params: {
            evidence_id: queryArg.evidenceId,
          },
        }),
        invalidatesTags: ["Files"],
      }),
      apiV1DownloadSiteAssessmentsAttachmentsRetrieve: build.query<
        ApiV1DownloadSiteAssessmentsAttachmentsRetrieveApiResponse,
        ApiV1DownloadSiteAssessmentsAttachmentsRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/download/site_assessments/${queryArg.processType}/attachments/${queryArg.attachmentId}/`,
        }),
        providesTags: ["Files"],
      }),
      apiV1NotificationsCurrentList: build.query<
        ApiV1NotificationsCurrentListApiResponse,
        ApiV1NotificationsCurrentListApiArg
      >({
        query: () => ({ url: `/api/v1/notifications/current` }),
        providesTags: ["Notifications"],
      }),
      apiV1NotificationsProductCreate: build.mutation<
        ApiV1NotificationsProductCreateApiResponse,
        ApiV1NotificationsProductCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/notifications/product`,
          method: "POST",
          body: queryArg.productNotification,
        }),
        invalidatesTags: ["Notifications"],
      }),
      apiV1NotificationsThemeAssignedCreate: build.mutation<
        ApiV1NotificationsThemeAssignedCreateApiResponse,
        ApiV1NotificationsThemeAssignedCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/notifications/theme_assigned/${queryArg.isAdded}`,
          method: "POST",
          body: queryArg.themeAssignedNotification,
        }),
        invalidatesTags: ["Machine Token"],
      }),
      apiV1ProtocolSetsList: build.query<ApiV1ProtocolSetsListApiResponse, ApiV1ProtocolSetsListApiArg>({
        query: () => ({ url: `/api/v1/protocol_sets/` }),
        providesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsRetrieve: build.query<ApiV1ProtocolSetsRetrieveApiResponse, ApiV1ProtocolSetsRetrieveApiArg>({
        query: queryArg => ({ url: `/api/v1/protocol_sets/${queryArg.id}` }),
        providesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsCleanupDestroy: build.mutation<
        ApiV1ProtocolSetsCleanupDestroyApiResponse,
        ApiV1ProtocolSetsCleanupDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/protocol_sets/${queryArg.id}/cleanup/`, method: "DELETE" }),
        invalidatesTags: ["api"],
      }),
      apiV1ProtocolSetsFiltersRetrieve: build.query<
        ApiV1ProtocolSetsFiltersRetrieveApiResponse,
        ApiV1ProtocolSetsFiltersRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/protocol_sets/${queryArg.id}/filters` }),
        providesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsInterlinkCreate: build.mutation<
        ApiV1ProtocolSetsInterlinkCreateApiResponse,
        ApiV1ProtocolSetsInterlinkCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/${queryArg.id}/interlink`,
          method: "POST",
          body: queryArg.linkProtocolQuestions,
        }),
        invalidatesTags: ["Protocols", "Protocol Sets"],
      }),
      apiV1ProtocolSetsProtocolQuestionCreate: build.mutation<
        ApiV1ProtocolSetsProtocolQuestionCreateApiResponse,
        ApiV1ProtocolSetsProtocolQuestionCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/${queryArg.id}/protocol_question`,
          method: "POST",
          body: queryArg.createProtocol,
        }),
        invalidatesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsProtocolQuestionsList: build.query<
        ApiV1ProtocolSetsProtocolQuestionsListApiResponse,
        ApiV1ProtocolSetsProtocolQuestionsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/${queryArg.id}/protocol_questions`,
          params: {
            ft_search: queryArg.ftSearch,
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            protocol_question__not: queryArg.protocolQuestionNot,
            requirement__not: queryArg.requirementNot,
            requirements: queryArg.requirements,
            scope_of_applicability: queryArg.scopeOfApplicability,
            search: queryArg.search,
            search_score_threshold: queryArg.searchScoreThreshold,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
          },
        }),
        providesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsProtocolQuestionsDownloadMappingXlsxRetrieve: build.mutation<
        ApiV1ProtocolSetsProtocolQuestionsDownloadMappingXlsxRetrieveApiResponse,
        ApiV1ProtocolSetsProtocolQuestionsDownloadMappingXlsxRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/${queryArg.id}/protocol_questions/download_mapping_xlsx`,
          method: "GET",
        }),
        invalidatesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsProtocolQuestionsDownloadXlsxRetrieve: build.mutation<
        ApiV1ProtocolSetsProtocolQuestionsDownloadXlsxRetrieveApiResponse,
        ApiV1ProtocolSetsProtocolQuestionsDownloadXlsxRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/${queryArg.id}/protocol_questions/download_xlsx`,
          method: "GET",
          params: {
            column: queryArg.column,
            ft_search: queryArg.ftSearch,
            ordering: queryArg.ordering,
            requirements: queryArg.requirements,
            scope_of_applicability: queryArg.scopeOfApplicability,
            search: queryArg.search,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
          },
        }),
        invalidatesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsProtocolQuestionsSmartSemanticSearchList: build.query<
        ApiV1ProtocolSetsProtocolQuestionsSmartSemanticSearchListApiResponse,
        ApiV1ProtocolSetsProtocolQuestionsSmartSemanticSearchListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/${queryArg.id}/protocol_questions/smart_semantic_search`,
          params: {
            limit: queryArg.limit,
            protocol_question__not: queryArg.protocolQuestionNot,
            requirement__not: queryArg.requirementNot,
            requirements: queryArg.requirements,
            scope_of_applicability: queryArg.scopeOfApplicability,
            search: queryArg.search,
            similarity_threshold: queryArg.similarityThreshold,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
          },
        }),
        providesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsPublishCreate: build.mutation<
        ApiV1ProtocolSetsPublishCreateApiResponse,
        ApiV1ProtocolSetsPublishCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/protocol_sets/${queryArg.id}/publish`, method: "POST" }),
        invalidatesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsSetToReviewCreate: build.mutation<
        ApiV1ProtocolSetsSetToReviewCreateApiResponse,
        ApiV1ProtocolSetsSetToReviewCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/protocol_sets/${queryArg.id}/set_to_review`, method: "POST" }),
        invalidatesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsCompareList: build.mutation<
        ApiV1ProtocolSetsCompareListApiResponse,
        ApiV1ProtocolSetsCompareListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/compare`,
          method: "GET",
          params: {
            left_id: queryArg.leftId,
            response_format: queryArg.responseFormat,
            right_id: queryArg.rightId,
          },
        }),
        invalidatesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsCreateDraftCreate: build.mutation<
        ApiV1ProtocolSetsCreateDraftCreateApiResponse,
        ApiV1ProtocolSetsCreateDraftCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/protocol_sets/create_draft`,
          method: "POST",
          body: queryArg.protocolSetSerializerCreateDraft,
        }),
        invalidatesTags: ["Protocol Sets"],
      }),
      apiV1ProtocolSetsLatestOrDraftRetrieve: build.query<
        ApiV1ProtocolSetsLatestOrDraftRetrieveApiResponse,
        ApiV1ProtocolSetsLatestOrDraftRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1/protocol_sets/latest_or_draft/` }),
        providesTags: ["api"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsList: build.query<
        ApiV1ReportsAssessmentsSiteAssessmentsListApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}`,
          params: {
            conformity_level: queryArg.conformityLevel,
            internal_audit_required: queryArg.internalAuditRequired,
            order: queryArg.order,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            query: queryArg.query,
            stakeholder_approval_required: queryArg.stakeholderApprovalRequired,
            standard_references: queryArg.standardReferences,
            status: queryArg.status,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
          },
        }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsDownloadCsvRetrieve: build.mutation<
        ApiV1ReportsAssessmentsSiteAssessmentsDownloadCsvRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsDownloadCsvRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/download_csv`,
          method: "GET",
          params: {
            column: queryArg.column,
            conformity_level: queryArg.conformityLevel,
            internal_audit_required: queryArg.internalAuditRequired,
            order: queryArg.order,
            query: queryArg.query,
            stakeholder_approval_required: queryArg.stakeholderApprovalRequired,
            standard_references: queryArg.standardReferences,
            status: queryArg.status,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
          },
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsDownloadXlsxRetrieve: build.mutation<
        ApiV1ReportsAssessmentsSiteAssessmentsDownloadXlsxRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsDownloadXlsxRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/download_xlsx`,
          method: "GET",
          params: {
            column: queryArg.column,
            conformity_level: queryArg.conformityLevel,
            internal_audit_required: queryArg.internalAuditRequired,
            order: queryArg.order,
            query: queryArg.query,
            stakeholder_approval_required: queryArg.stakeholderApprovalRequired,
            standard_references: queryArg.standardReferences,
            status: queryArg.status,
            sub_theme: queryArg.subTheme,
            theme: queryArg.theme,
          },
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsFiltersRetrieve: build.query<
        ApiV1ReportsAssessmentsSiteAssessmentsFiltersRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsFiltersRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/filters`,
        }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaRetrieve: build.query<
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/standards/${queryArg.standardId}/irma`,
        }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaXlsxRetrieve: build.mutation<
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaXlsxRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaXlsxRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/standards/${queryArg.standardId}/irma_xlsx`,
          method: "GET",
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsStandardsRollupList: build.query<
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupListApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/standards/${queryArg.standardId}/rollup/${queryArg.isRollup}`,
          params: {
            aggregate_level: queryArg.aggregateLevel,
            conformity_level: queryArg.conformityLevel,
            order: queryArg.order,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            query: queryArg.query,
            section: queryArg.section,
            sub_section: queryArg.subSection,
          },
        }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadCsvRetrieve: build.mutation<
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadCsvRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadCsvRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/standards/${queryArg.standardId}/rollup/${queryArg.isRollup}/download_csv`,
          method: "GET",
          params: {
            aggregate_level: queryArg.aggregateLevel,
            column: queryArg.column,
            conformity_level: queryArg.conformityLevel,
            order: queryArg.order,
            query: queryArg.query,
            section: queryArg.section,
            sub_section: queryArg.subSection,
          },
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadXlsxRetrieve: build.mutation<
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadXlsxRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadXlsxRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/standards/${queryArg.standardId}/rollup/${queryArg.isRollup}/download_xlsx`,
          method: "GET",
          params: {
            aggregate_level: queryArg.aggregateLevel,
            column: queryArg.column,
            conformity_level: queryArg.conformityLevel,
            order: queryArg.order,
            query: queryArg.query,
            section: queryArg.section,
            sub_section: queryArg.subSection,
          },
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsAssessmentsSiteAssessmentsStandardsRollupFiltersRetrieve: build.query<
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupFiltersRetrieveApiResponse,
        ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupFiltersRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/assessments/${queryArg.assessmentId}/site_assessments/${queryArg.siteAssessmentId}/standards/${queryArg.standardId}/rollup/${queryArg.isRollup}/filters`,
        }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsCustomList: build.query<ApiV1ReportsCustomListApiResponse, ApiV1ReportsCustomListApiArg>({
        query: queryArg => ({
          url: `/api/v1/reports/custom/`,
          params: {
            assessment_status: queryArg.assessmentStatus,
            assessments: queryArg.assessments,
            search: queryArg.search,
            sites: queryArg.sites,
            standards: queryArg.standards,
          },
        }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsCustomCreate: build.mutation<ApiV1ReportsCustomCreateApiResponse, ApiV1ReportsCustomCreateApiArg>({
        query: queryArg => ({
          url: `/api/v1/reports/custom/`,
          method: "POST",
          body: queryArg.customReportCreate,
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsCustomRetrieve: build.query<ApiV1ReportsCustomRetrieveApiResponse, ApiV1ReportsCustomRetrieveApiArg>({
        query: queryArg => ({ url: `/api/v1/reports/custom/${queryArg.id}/` }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsCustomPartialUpdate: build.mutation<
        ApiV1ReportsCustomPartialUpdateApiResponse,
        ApiV1ReportsCustomPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/custom/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedCustomReportPartialUpdate,
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsCustomDestroy: build.mutation<ApiV1ReportsCustomDestroyApiResponse, ApiV1ReportsCustomDestroyApiArg>({
        query: queryArg => ({ url: `/api/v1/reports/custom/${queryArg.id}/`, method: "DELETE" }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsCustomDownloadCsvRetrieve: build.mutation<
        ApiV1ReportsCustomDownloadCsvRetrieveApiResponse,
        ApiV1ReportsCustomDownloadCsvRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/custom/${queryArg.reportId}/download_csv`,
          method: "GET",
          params: {
            columns: queryArg.columns,
            conformity_level: queryArg.conformityLevel,
            reference: queryArg.reference,
            search: queryArg.search,
            section: queryArg.section,
            standard_name: queryArg.standardName,
            sub_section: queryArg.subSection,
          },
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1ReportsCustomDownloadXlsxRetrieve: build.mutation<
        ApiV1ReportsCustomDownloadXlsxRetrieveApiResponse,
        ApiV1ReportsCustomDownloadXlsxRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/custom/${queryArg.reportId}/download_xlsx`,
          method: "GET",
          params: {
            columns: queryArg.columns,
            conformity_level: queryArg.conformityLevel,
            reference: queryArg.reference,
            search: queryArg.search,
            section: queryArg.section,
            standard_name: queryArg.standardName,
            sub_section: queryArg.subSection,
          },
        }),
        invalidatesTags: ["Reports"],
      }),
      apiV1CustomReportFiltersDetail: build.query<
        ApiV1CustomReportFiltersDetailApiResponse,
        ApiV1CustomReportFiltersDetailApiArg
      >({
        query: queryArg => ({ url: `/api/v1/reports/custom/${queryArg.reportId}/filters` }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsCustomGetDataRetrieve: build.query<
        ApiV1ReportsCustomGetDataRetrieveApiResponse,
        ApiV1ReportsCustomGetDataRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/reports/custom/${queryArg.reportId}/get_data`,
          params: {
            conformity_level: queryArg.conformityLevel,
            reference: queryArg.reference,
            search: queryArg.search,
            section: queryArg.section,
            standard_name: queryArg.standardName,
            sub_section: queryArg.subSection,
          },
        }),
        providesTags: ["Reports"],
      }),
      apiV1ReportsCustomFiltersRetrieve: build.query<
        ApiV1ReportsCustomFiltersRetrieveApiResponse,
        ApiV1ReportsCustomFiltersRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1/reports/custom/filters/` }),
        providesTags: ["Reports"],
      }),
      apiV1ScopesOfApplicabilityList: build.query<
        ApiV1ScopesOfApplicabilityListApiResponse,
        ApiV1ScopesOfApplicabilityListApiArg
      >({
        query: () => ({ url: `/api/v1/scopes_of_applicability/` }),
        providesTags: ["Scope of Applicability"],
      }),
      apiV1StandardsProtocolsRetrieve: build.query<
        ApiV1StandardsProtocolsRetrieveApiResponse,
        ApiV1StandardsProtocolsRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/protocols/${queryArg.id}/` }),
        providesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsUpdate: build.mutation<
        ApiV1StandardsProtocolsUpdateApiResponse,
        ApiV1StandardsProtocolsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/protocols/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.createProtocol,
        }),
        invalidatesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsPartialUpdate: build.mutation<
        ApiV1StandardsProtocolsPartialUpdateApiResponse,
        ApiV1StandardsProtocolsPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/protocols/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedCreateProtocol,
        }),
        invalidatesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsDestroy: build.mutation<
        ApiV1StandardsProtocolsDestroyApiResponse,
        ApiV1StandardsProtocolsDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/protocols/${queryArg.id}/`, method: "DELETE" }),
        invalidatesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsDuplicateCreate: build.mutation<
        ApiV1StandardsProtocolsDuplicateCreateApiResponse,
        ApiV1StandardsProtocolsDuplicateCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/protocols/${queryArg.id}/duplicate/`, method: "POST" }),
        invalidatesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsRelatedProtocolsList: build.query<
        ApiV1StandardsProtocolsRelatedProtocolsListApiResponse,
        ApiV1StandardsProtocolsRelatedProtocolsListApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/protocols/${queryArg.id}/related_protocols` }),
        providesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsRelatedProtocolsCreate: build.mutation<
        ApiV1StandardsProtocolsRelatedProtocolsCreateApiResponse,
        ApiV1StandardsProtocolsRelatedProtocolsCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/protocols/${queryArg.id}/related_protocols`,
          method: "POST",
          body: queryArg.linkProtocolQuestions,
        }),
        invalidatesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsRelatedProtocolsDestroy: build.mutation<
        ApiV1StandardsProtocolsRelatedProtocolsDestroyApiResponse,
        ApiV1StandardsProtocolsRelatedProtocolsDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/protocols/${queryArg.id}/related_protocols/${queryArg.relatedProtocolId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsShowHistoryList: build.query<
        ApiV1StandardsProtocolsShowHistoryListApiResponse,
        ApiV1StandardsProtocolsShowHistoryListApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/protocols/${queryArg.id}/show_history/` }),
        providesTags: ["Protocols"],
      }),
      apiV1StandardsProtocolsReorderCreate: build.mutation<
        ApiV1StandardsProtocolsReorderCreateApiResponse,
        ApiV1StandardsProtocolsReorderCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/protocols/reorder/`,
          method: "POST",
          body: queryArg.protocolQuestionReorder,
        }),
        invalidatesTags: ["Protocols"],
      }),
      apiV1StandardsRequirementsList: build.query<
        ApiV1StandardsRequirementsListApiResponse,
        ApiV1StandardsRequirementsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/`,
          params: {
            is_mapped: queryArg.isMapped,
            ordering: queryArg.ordering,
            page: queryArg.page,
            prefetch_protocol_set_id: queryArg.prefetchProtocolSetId,
            protocol: queryArg.protocol,
            protocol__not: queryArg.protocolNot,
            questions: queryArg.questions,
            search: queryArg.search,
            standard: queryArg.standard,
          },
        }),
        providesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsCreate: build.mutation<
        ApiV1StandardsRequirementsCreateApiResponse,
        ApiV1StandardsRequirementsCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/`,
          method: "POST",
          body: queryArg.requirementWrite,
        }),
        invalidatesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsRetrieve: build.query<
        ApiV1StandardsRequirementsRetrieveApiResponse,
        ApiV1StandardsRequirementsRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/requirements/${queryArg.id}` }),
        providesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsUpdate: build.mutation<
        ApiV1StandardsRequirementsUpdateApiResponse,
        ApiV1StandardsRequirementsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/${queryArg.id}`,
          method: "PUT",
          body: queryArg.requirementWrite,
        }),
        invalidatesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsPartialUpdate: build.mutation<
        ApiV1StandardsRequirementsPartialUpdateApiResponse,
        ApiV1StandardsRequirementsPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/${queryArg.id}`,
          method: "PATCH",
          body: queryArg.patchedRequirementWrite,
        }),
        invalidatesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsDestroy: build.mutation<
        ApiV1StandardsRequirementsDestroyApiResponse,
        ApiV1StandardsRequirementsDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/requirements/${queryArg.id}`, method: "DELETE" }),
        invalidatesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsFiltersRetrieve: build.query<
        ApiV1StandardsRequirementsFiltersRetrieveApiResponse,
        ApiV1StandardsRequirementsFiltersRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1/standards/requirements/filters` }),
        providesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsLinkProtocolQuestionsCreate: build.mutation<
        ApiV1StandardsRequirementsLinkProtocolQuestionsCreateApiResponse,
        ApiV1StandardsRequirementsLinkProtocolQuestionsCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/link_protocol_questions`,
          method: "POST",
          body: queryArg.linkProtocolQuestion,
        }),
        invalidatesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsLinkToProtocolQuestionCreate: build.mutation<
        ApiV1StandardsRequirementsLinkToProtocolQuestionCreateApiResponse,
        ApiV1StandardsRequirementsLinkToProtocolQuestionCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/link_to_protocol_question`,
          method: "POST",
          body: queryArg.linkRequirement,
        }),
        invalidatesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsLiteList: build.query<
        ApiV1StandardsRequirementsLiteListApiResponse,
        ApiV1StandardsRequirementsLiteListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/lite/`,
          params: {
            is_mapped: queryArg.isMapped,
            page: queryArg.page,
            protocol: queryArg.protocol,
            protocol__not: queryArg.protocolNot,
            questions: queryArg.questions,
            search: queryArg.search,
            search_score_threshold: queryArg.searchScoreThreshold,
            standard: queryArg.standard,
          },
        }),
        providesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsSmartSemanticSearchList: build.query<
        ApiV1StandardsRequirementsSmartSemanticSearchListApiResponse,
        ApiV1StandardsRequirementsSmartSemanticSearchListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/smart_semantic_search`,
          params: {
            is_mapped: queryArg.isMapped,
            limit: queryArg.limit,
            protocol: queryArg.protocol,
            protocol__not: queryArg.protocolNot,
            questions: queryArg.questions,
            search: queryArg.search,
            similarity_threshold: queryArg.similarityThreshold,
            standard: queryArg.standard,
          },
        }),
        providesTags: ["Requirements"],
      }),
      apiV1StandardsRequirementsUnlinkFromProtocolQuestionCreate: build.mutation<
        ApiV1StandardsRequirementsUnlinkFromProtocolQuestionCreateApiResponse,
        ApiV1StandardsRequirementsUnlinkFromProtocolQuestionCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/requirements/unlink_from_protocol_question`,
          method: "POST",
          body: queryArg.linkRequirement,
        }),
        invalidatesTags: ["Requirements"],
      }),
      apiV1StandardsStandardGuidanceList: build.query<
        ApiV1StandardsStandardGuidanceListApiResponse,
        ApiV1StandardsStandardGuidanceListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standard_guidance/`,
          params: {
            search: queryArg.search,
            standard: queryArg.standard,
            type: queryArg["type"],
          },
        }),
        providesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardGuidanceCreate: build.mutation<
        ApiV1StandardsStandardGuidanceCreateApiResponse,
        ApiV1StandardsStandardGuidanceCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standard_guidance/`,
          method: "POST",
          body: queryArg.standardGuidance,
        }),
        invalidatesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardGuidanceRetrieve: build.query<
        ApiV1StandardsStandardGuidanceRetrieveApiResponse,
        ApiV1StandardsStandardGuidanceRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/standard_guidance/${queryArg.id}/` }),
        providesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardGuidanceUpdate: build.mutation<
        ApiV1StandardsStandardGuidanceUpdateApiResponse,
        ApiV1StandardsStandardGuidanceUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standard_guidance/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.standardGuidance,
        }),
        invalidatesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardGuidancePartialUpdate: build.mutation<
        ApiV1StandardsStandardGuidancePartialUpdateApiResponse,
        ApiV1StandardsStandardGuidancePartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standard_guidance/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedStandardGuidance,
        }),
        invalidatesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardGuidanceDestroy: build.mutation<
        ApiV1StandardsStandardGuidanceDestroyApiResponse,
        ApiV1StandardsStandardGuidanceDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/standard_guidance/${queryArg.id}/`, method: "DELETE" }),
        invalidatesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardGuidanceLinkToRequirementCreate: build.mutation<
        ApiV1StandardsStandardGuidanceLinkToRequirementCreateApiResponse,
        ApiV1StandardsStandardGuidanceLinkToRequirementCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standard_guidance/link_to_requirement`,
          method: "POST",
          body: queryArg.linkStandardGuidance,
        }),
        invalidatesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardGuidanceUnlinkFromRequirementCreate: build.mutation<
        ApiV1StandardsStandardGuidanceUnlinkFromRequirementCreateApiResponse,
        ApiV1StandardsStandardGuidanceUnlinkFromRequirementCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standard_guidance/unlink_from_requirement`,
          method: "POST",
          body: queryArg.linkStandardGuidance,
        }),
        invalidatesTags: ["Standard Guidance"],
      }),
      apiV1StandardsStandardsList: build.query<
        ApiV1StandardsStandardsListApiResponse,
        ApiV1StandardsStandardsListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/`,
          params: {
            ordering: queryArg.ordering,
            published_date: queryArg.publishedDate,
            published_date__gt: queryArg.publishedDateGt,
            published_date__lt: queryArg.publishedDateLt,
            search: queryArg.search,
            show_all: queryArg.showAll,
            tenants: queryArg.tenants,
            tenants__isnull: queryArg.tenantsIsnull,
            version: queryArg.version,
          },
        }),
        providesTags: ["Standards"],
      }),
      apiV1StandardsStandardsCreate: build.mutation<
        ApiV1StandardsStandardsCreateApiResponse,
        ApiV1StandardsStandardsCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/standards/`, method: "POST", body: queryArg.standard }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsRetrieve: build.query<
        ApiV1StandardsStandardsRetrieveApiResponse,
        ApiV1StandardsStandardsRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/standards/${queryArg.id}/` }),
        providesTags: ["Standards"],
      }),
      apiV1StandardsStandardsUpdate: build.mutation<
        ApiV1StandardsStandardsUpdateApiResponse,
        ApiV1StandardsStandardsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.standard,
        }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsPartialUpdate: build.mutation<
        ApiV1StandardsStandardsPartialUpdateApiResponse,
        ApiV1StandardsStandardsPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedStandard,
        }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsDestroy: build.mutation<
        ApiV1StandardsStandardsDestroyApiResponse,
        ApiV1StandardsStandardsDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/standards/${queryArg.id}/`, method: "DELETE" }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsSectionsList: build.query<
        ApiV1StandardsStandardsSectionsListApiResponse,
        ApiV1StandardsStandardsSectionsListApiArg
      >({
        query: queryArg => ({ url: `/api/v1/standards/standards/${queryArg.standardId}/sections` }),
        providesTags: ["Standards"],
      }),
      apiV1StandardsStandardsSectionsCreate: build.mutation<
        ApiV1StandardsStandardsSectionsCreateApiResponse,
        ApiV1StandardsStandardsSectionsCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/${queryArg.standardId}/sections`,
          method: "POST",
          body: queryArg.sectionCreate,
        }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsSectionsCreate2: build.mutation<
        ApiV1StandardsStandardsSectionsCreate2ApiResponse,
        ApiV1StandardsStandardsSectionsCreate2ApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/${queryArg.standardId}/sections/${queryArg.sectionId}`,
          method: "POST",
          body: queryArg.sectionCreate,
        }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsSectionsUpdate: build.mutation<
        ApiV1StandardsStandardsSectionsUpdateApiResponse,
        ApiV1StandardsStandardsSectionsUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/${queryArg.standardId}/sections/${queryArg.sectionId}`,
          method: "PUT",
          body: queryArg.sectionCreate,
        }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsSectionsDestroy: build.mutation<
        ApiV1StandardsStandardsSectionsDestroyApiResponse,
        ApiV1StandardsStandardsSectionsDestroyApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/${queryArg.standardId}/sections/${queryArg.sectionId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Standards"],
      }),
      apiV1StandardsStandardsFiltersRetrieve: build.query<
        ApiV1StandardsStandardsFiltersRetrieveApiResponse,
        ApiV1StandardsStandardsFiltersRetrieveApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/standards/filters/`,
          params: {
            show_all: queryArg.showAll,
          },
        }),
        providesTags: ["Standards"],
      }),
      apiV1StandardsSubthemesList: build.query<
        ApiV1StandardsSubthemesListApiResponse,
        ApiV1StandardsSubthemesListApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/standards/subthemes/`,
          params: {
            ordering: queryArg.ordering,
          },
        }),
        providesTags: ["SubThemes"],
      }),
      apiV1StandardsThemesList: build.query<ApiV1StandardsThemesListApiResponse, ApiV1StandardsThemesListApiArg>({
        query: queryArg => ({
          url: `/api/v1/standards/themes/`,
          params: {
            ordering: queryArg.ordering,
          },
        }),
        providesTags: ["Themes"],
      }),
      apiV1UploadRetrieve: build.mutation<ApiV1UploadRetrieveApiResponse, ApiV1UploadRetrieveApiArg>({
        query: queryArg => ({
          url: `/api/v1/upload/`,
          method: "GET",
          params: {
            obj_name: queryArg.objName,
          },
        }),
        invalidatesTags: ["Files"],
      }),
      apiV1UserManagementList: build.query<ApiV1UserManagementListApiResponse, ApiV1UserManagementListApiArg>({
        query: queryArg => ({
          url: `/api/v1/user_management/`,
          params: {
            ordering: queryArg.ordering,
            page: queryArg.page,
            page_size: queryArg.pageSize,
            search: queryArg.search,
            user_status: queryArg.userStatus,
          },
        }),
        providesTags: ["User Management"],
      }),
      apiV1UserManagementCreate: build.mutation<ApiV1UserManagementCreateApiResponse, ApiV1UserManagementCreateApiArg>({
        query: queryArg => ({
          url: `/api/v1/user_management/`,
          method: "POST",
          body: queryArg.userManagement,
        }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementRetrieve: build.query<
        ApiV1UserManagementRetrieveApiResponse,
        ApiV1UserManagementRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/user_management/${queryArg.id}/` }),
        providesTags: ["User Management"],
      }),
      apiV1UserManagementUpdate: build.mutation<ApiV1UserManagementUpdateApiResponse, ApiV1UserManagementUpdateApiArg>({
        query: queryArg => ({
          url: `/api/v1/user_management/${queryArg.id}/`,
          method: "PUT",
          body: queryArg.userManagement,
        }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementDestroy: build.mutation<
        ApiV1UserManagementDestroyApiResponse,
        ApiV1UserManagementDestroyApiArg
      >({
        query: queryArg => ({ url: `/api/v1/user_management/${queryArg.id}/`, method: "DELETE" }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementDeactivateCreate: build.mutation<
        ApiV1UserManagementDeactivateCreateApiResponse,
        ApiV1UserManagementDeactivateCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/user_management/${queryArg.id}/deactivate/`, method: "POST" }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementReactivateCreate: build.mutation<
        ApiV1UserManagementReactivateCreateApiResponse,
        ApiV1UserManagementReactivateCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/user_management/${queryArg.id}/reactivate/`, method: "POST" }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementReinviteCreate: build.mutation<
        ApiV1UserManagementReinviteCreateApiResponse,
        ApiV1UserManagementReinviteCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/user_management/${queryArg.id}/reinvite/`, method: "POST" }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementResetMfaCreate: build.mutation<
        ApiV1UserManagementResetMfaCreateApiResponse,
        ApiV1UserManagementResetMfaCreateApiArg
      >({
        query: queryArg => ({ url: `/api/v1/user_management/${queryArg.id}/reset_mfa/`, method: "POST" }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementResetPasswordCreate: build.mutation<
        ApiV1UserManagementResetPasswordCreateApiResponse,
        ApiV1UserManagementResetPasswordCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/user_management/${queryArg.id}/reset_password/`,
          method: "POST",
        }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementFiltersRetrieve: build.query<
        ApiV1UserManagementFiltersRetrieveApiResponse,
        ApiV1UserManagementFiltersRetrieveApiArg
      >({
        query: () => ({ url: `/api/v1/user_management/filters/` }),
        providesTags: ["User Management"],
      }),
      apiV1UserManagementInviteAdminCreate: build.mutation<
        ApiV1UserManagementInviteAdminCreateApiResponse,
        ApiV1UserManagementInviteAdminCreateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/user_management/invite_admin/`,
          method: "POST",
          body: queryArg.userManagementBase,
        }),
        invalidatesTags: ["User Management"],
      }),
      apiV1UserManagementProfileUpdate: build.mutation<
        ApiV1UserManagementProfileUpdateApiResponse,
        ApiV1UserManagementProfileUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/user_management/profile/`,
          method: "PUT",
          body: queryArg.userProfile,
        }),
        invalidatesTags: ["User Profile"],
      }),
      apiV1UserPreferencesList: build.query<ApiV1UserPreferencesListApiResponse, ApiV1UserPreferencesListApiArg>({
        query: () => ({ url: `/api/v1/user_preferences` }),
        providesTags: ["api"],
      }),
      apiV1UserPreferencesRetrieve: build.query<
        ApiV1UserPreferencesRetrieveApiResponse,
        ApiV1UserPreferencesRetrieveApiArg
      >({
        query: queryArg => ({ url: `/api/v1/user_preferences/${queryArg.tableName}` }),
        providesTags: ["api"],
      }),
      apiV1UserPreferencesUpdate: build.mutation<
        ApiV1UserPreferencesUpdateApiResponse,
        ApiV1UserPreferencesUpdateApiArg
      >({
        query: queryArg => ({
          url: `/api/v1/user_preferences/${queryArg.tableName}`,
          method: "PUT",
          body: queryArg.userPreference,
        }),
        invalidatesTags: ["api"],
      }),
      apiV1UsersList: build.query<ApiV1UsersListApiResponse, ApiV1UsersListApiArg>({
        query: queryArg => ({
          url: `/api/v1/users/`,
          params: {
            excluded_groups: queryArg.excludedGroups,
            group: queryArg.group,
            ordering: queryArg.ordering,
          },
        }),
        providesTags: ["Users"],
      }),
      whoamiRetrieve: build.query<WhoamiRetrieveApiResponse, WhoamiRetrieveApiArg>({
        query: () => ({ url: `/whoami/` }),
        providesTags: ["WhoAmI"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as api };
export type ApiV1AdminMappingJobsDownloadRetrieveApiResponse = unknown;
export type ApiV1AdminMappingJobsDownloadRetrieveApiArg = {
  /** A unique integer value identifying this mapping job. */
  id: number;
};
export type ApiV1AdminMappingJobsProgressRetrieveApiResponse =
  /** status 200 Job progress and status */ MappingJobProgress;
export type ApiV1AdminMappingJobsProgressRetrieveApiArg = {
  /** A unique integer value identifying this mapping job. */
  id: number;
};
export type ApiV1AdminMappingJobsDumpCreateApiResponse = /** status 202 Dump job queued successfully */ MappingJobRead;
export type ApiV1AdminMappingJobsDumpCreateApiArg = void;
export type ApiV1AdminMappingJobsLoadCreateApiResponse = /** status 202 Load job queued successfully */ MappingJobRead;
export type ApiV1AdminMappingJobsLoadCreateApiArg = {
  body: {
    /** JSON dump file to upload */
    file: Blob;
  };
};
export type ApiV1AdminUserReportRetrieveApiResponse = unknown;
export type ApiV1AdminUserReportRetrieveApiArg = {
  /** Exclude ERM domain email addresses. Defaults to true. */
  excludeErm?: boolean;
  /** Exclude users in these groups, comma-separated */
  excludedGroups?: string;
  /** User group name */
  group?: string;
  tenantId: string;
};
export type ApiV1AssessmentsCleanupDestroyApiResponse = unknown;
export type ApiV1AssessmentsCleanupDestroyApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsThemeProgressListApiResponse = /** status 200  */ SiteAssessmentThemeProgress[];
export type ApiV1AssessmentsThemeProgressListApiArg = {
  assessmentId: string;
  /** Filter results by specific site assessment ID. */
  siteAssessmentId?: string;
};
export type ApiV1AssessmentsAssessmentsListApiResponse = /** status 200  */ PaginatedAssessmentRetrieveListRead;
export type ApiV1AssessmentsAssessmentsListApiArg = {
  /** Parameter for querying active/inactive assessments. By default this is set to true. */
  active?: boolean;
  /** Parameter for querying completed/not completed assessments. If not set, all assessments will be retrieved */
  completed?: boolean;
  /** If true, return only assessments favorited by the current user. If false, exclude favorited assessments. If omitted, do not filter by favorites. */
  favorite?: boolean;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
};
export type ApiV1AssessmentsAssessmentsCreateApiResponse = /** status 201  */ AssessmentCreateRead;
export type ApiV1AssessmentsAssessmentsCreateApiArg = {
  assessmentCreateRequest: AssessmentCreateRequestWrite;
};
export type ApiV1AssessmentsAssessmentsRetrieveApiResponse = /** status 200  */ AssessmentRetrieveRead;
export type ApiV1AssessmentsAssessmentsRetrieveApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsUpdateApiResponse = /** status 200  */ AssessmentUpdateRead;
export type ApiV1AssessmentsAssessmentsUpdateApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
  assessmentRequest: AssessmentRequestWrite;
};
export type ApiV1AssessmentsAssessmentsPartialUpdateApiResponse = /** status 200  */ AssessmentPartialUpdate;
export type ApiV1AssessmentsAssessmentsPartialUpdateApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
  patchedAssessmentPartialUpdate: PatchedAssessmentPartialUpdate;
};
export type ApiV1AssessmentsAssessmentsDestroyApiResponse = unknown;
export type ApiV1AssessmentsAssessmentsDestroyApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsCommentsListApiResponse =
  /** status 200  */ SiteAssessmentWithRecentCommentsRead[];
export type ApiV1AssessmentsAssessmentsCommentsListApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsCompleteCreateApiResponse = /** status 200  */ AssessmentRead;
export type ApiV1AssessmentsAssessmentsCompleteCreateApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsFavoriteCreateApiResponse = unknown;
export type ApiV1AssessmentsAssessmentsFavoriteCreateApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsFavoriteDestroyApiResponse = unknown;
export type ApiV1AssessmentsAssessmentsFavoriteDestroyApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsProtocolQuestionsListApiResponse =
  /** status 200  */ AvailableProtocolQuestionsThemeRead[];
export type ApiV1AssessmentsAssessmentsProtocolQuestionsListApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsProtocolQuestionsTasksListApiResponse = /** status 200  */ TaskInProtocolRead[];
export type ApiV1AssessmentsAssessmentsProtocolQuestionsTasksListApiArg = {
  assessmentId: string;
  protocolQuestionId: number;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentRetrieveApiResponse = /** status 200  */ RevieweAssignmentRead;
export type ApiV1AssessmentsAssessmentsReviewAssignmentRetrieveApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsCreateApiResponse = /** status 200  */ ReviewersRead;
export type ApiV1AssessmentsAssessmentsReviewAssignmentsCreateApiArg = {
  assessmentId: string;
  reviewAssignmentCreateUpdate: ReviewAssignmentCreateUpdate;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsRetrieveApiResponse =
  /** status 200  */ ReviewAssignedThemesRead;
export type ApiV1AssessmentsAssessmentsReviewAssignmentsRetrieveApiArg = {
  assessmentId: string;
  assignmentId: number;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsUpdateApiResponse = /** status 200  */ ReviewersRead;
export type ApiV1AssessmentsAssessmentsReviewAssignmentsUpdateApiArg = {
  assessmentId: string;
  assignmentId: number;
  reviewAssignmentCreateUpdate: ReviewAssignmentCreateUpdate;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsDestroyApiResponse = unknown;
export type ApiV1AssessmentsAssessmentsReviewAssignmentsDestroyApiArg = {
  assessmentId: string;
  assignmentId: number;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsAvailableStepsRetrieveApiResponse =
  /** status 200  */ ReviewersRead;
export type ApiV1AssessmentsAssessmentsReviewAssignmentsAvailableStepsRetrieveApiArg = {
  assessmentId: string;
  /** ID of Themes Group */
  themesGroupId: number;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsReviewersRetrieveApiResponse = /** status 200  */ ReviewersRead;
export type ApiV1AssessmentsAssessmentsReviewAssignmentsReviewersRetrieveApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsStepsListApiResponse =
  /** status 200  */ StepsFieldForAssigning[];
export type ApiV1AssessmentsAssessmentsReviewAssignmentsStepsListApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsStepsAssignedThemesListApiResponse =
  /** status 200  */ ReviewAssignedThemesRead[];
export type ApiV1AssessmentsAssessmentsReviewAssignmentsStepsAssignedThemesListApiArg = {
  assessmentId: string;
  stepId: number;
};
export type ApiV1AssessmentsAssessmentsReviewAssignmentsStepsUnassignedThemesListApiResponse =
  /** status 200  */ UnassignedThemeRead[];
export type ApiV1AssessmentsAssessmentsReviewAssignmentsStepsUnassignedThemesListApiArg = {
  assessmentId: string;
  stepId: number;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsListApiResponse = /** status 200  */ SiteAssessmentRead[];
export type ApiV1AssessmentsAssessmentsSiteAssessmentsListApiArg = {
  assessmentId: string;
  /** Site id */
  siteId?: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsRetrieveApiResponse = /** status 200  */ SiteAssessmentRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsRetrieveApiArg = {
  assessmentId: string;
  id: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalRetrieveApiResponse =
  /** status 200  */ SiteAssessmentApprovalRetrieveRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalRetrieveApiArg = {
  assessmentId: string;
  id: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateApiResponse =
  /** status 200  */ SiteAssessmentApprovalCreatedRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentApprovalCreate: SiteAssessmentApprovalCreate;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsAssignCreateApiResponse = /** status 200  */ SiteAssessmentRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsAssignCreateApiArg = {
  assessmentId: string;
  id: string;
  assignThemes: AssignThemes;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsAssignedRetrieveApiResponse =
  /** status 200  */ AssignedThemesRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsAssignedRetrieveApiArg = {
  assessmentId: string;
  id: string;
  /** Site id */
  siteId?: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsCommentsListApiResponse =
  /** status 200  */ TaskWithRecentCommentsRead[];
export type ApiV1AssessmentsAssessmentsSiteAssessmentsCommentsListApiArg = {
  assessmentId: string;
  id: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationRetrieveApiResponse =
  /** status 200  */ SiteAssessmentVerificationRetrieveRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationRetrieveApiArg = {
  assessmentId: string;
  id: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationCreateApiResponse =
  /** status 200  */ SiteAssessmentVerificationCreatedRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationCreateApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentVerificationCreate: SiteAssessmentVerificationCreate;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksListApiResponse = /** status 200  */ TaskRead[];
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksListApiArg = {
  assessmentId: string;
  siteAssessmentId: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRetrieveApiResponse = /** status 200  */ GetTaskRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRetrieveApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsListApiResponse = /** status 200  */ CommentRead[];
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsListApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsCreateApiResponse = /** status 200  */ CommentRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsCreateApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
  commentWithLink: CommentWithLink;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsUpdateApiResponse = /** status 200  */ CommentRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsUpdateApiArg = {
  assessmentId: string;
  commentId: string;
  id: string;
  siteAssessmentId: string;
  commentWithLink: CommentWithLink;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsDestroyApiResponse = unknown;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsDestroyApiArg = {
  assessmentId: string;
  commentId: string;
  id: string;
  siteAssessmentId: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksEvidencesUpdateApiResponse =
  /** status 200  */ EvidenceRead[];
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksEvidencesUpdateApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
  body: Evidence[];
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRelatedUsersRetrieveApiResponse =
  /** status 200  */ TaskRelatedUserRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksRelatedUsersRetrieveApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromOtherSitesListApiResponse =
  /** status 200  */ TaskFromOtherSitesRead[];
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromOtherSitesListApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromRelatedQuestionsListApiResponse =
  /** status 200  */ TaskFromRelatedProtocolRead[];
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromRelatedQuestionsListApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksReviewCreateApiResponse = /** status 200  */ Review;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksReviewCreateApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
  review: Review;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksSavePublishedChangesCreateApiResponse =
  /** status 200  */ AnswerRead;
export type ApiV1AssessmentsAssessmentsSiteAssessmentsTasksSavePublishedChangesCreateApiArg = {
  assessmentId: string;
  id: string;
  siteAssessmentId: string;
  answer: Answer;
};
export type ApiV1AssessmentsAssessmentsSitesWithStandardsListApiResponse =
  /** status 200  */ SiteWithRelatedStandardsRead[];
export type ApiV1AssessmentsAssessmentsSitesWithStandardsListApiArg = {
  /** A UUID string identifying this assessment. */
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsUpdateApiResponse = /** status 200  */ VerifierStepDetailRead;
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsUpdateApiArg = {
  assessmentId: string;
  assignVerifiers: AssignVerifiers;
};
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsDeleteStepDestroyApiResponse = unknown;
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsDeleteStepDestroyApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsStepDetailsRetrieveApiResponse =
  /** status 200  */ VerifierStepDetailRead;
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsStepDetailsRetrieveApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsVerifiersListApiResponse = /** status 200  */ UserRead[];
export type ApiV1AssessmentsAssessmentsVerifierAssignmentsVerifiersListApiArg = {
  assessmentId: string;
};
export type ApiV1AssessmentsEvidencesListApiResponse = /** status 200  */ PaginatedEvidenceFileListRead;
export type ApiV1AssessmentsEvidencesListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** When present files will be filtered by file_name. Is case insensitive */
  q?: string;
};
export type ApiV1AssessmentsSiteAssessmentsAvailableStandardsListApiResponse = /** status 200  */ StandardRead[];
export type ApiV1AssessmentsSiteAssessmentsAvailableStandardsListApiArg = {
  siteAssessmentId: string;
};
export type ApiV1AssessmentsSiteAssessmentsAvailableTasksListApiResponse = /** status 200  */ AvailableTasksThemeRead[];
export type ApiV1AssessmentsSiteAssessmentsAvailableTasksListApiArg = {
  siteAssessmentId: string;
  /** list of status separated by comma */
  status?: string;
};
export type ApiV1AssessmentsSiteAssessmentsAvailableTasksStandardListApiResponse =
  /** status 200  */ AvailableTasksSectionRead[];
export type ApiV1AssessmentsSiteAssessmentsAvailableTasksStandardListApiArg = {
  siteAssessmentId: string;
  standardId: number;
  /** list of status separated by comma */
  status?: string;
};
export type ApiV1AssessmentsSitesListApiResponse = /** status 200  */ PaginatedGetSiteListRead;
export type ApiV1AssessmentsSitesListApiArg = {
  coordinator?: string[];
  country?: string[];
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  type?: number[];
};
export type ApiV1AssessmentsSitesCreateApiResponse = /** status 201  */ GetSiteRead;
export type ApiV1AssessmentsSitesCreateApiArg = {
  writeSite: WriteSite;
};
export type ApiV1AssessmentsSitesRetrieveApiResponse = /** status 200  */ GetSiteRead;
export type ApiV1AssessmentsSitesRetrieveApiArg = {
  /** A UUID string identifying this site. */
  id: string;
};
export type ApiV1AssessmentsSitesUpdateApiResponse = /** status 200  */ GetSiteRead;
export type ApiV1AssessmentsSitesUpdateApiArg = {
  /** A UUID string identifying this site. */
  id: string;
  writeSite: WriteSite;
};
export type ApiV1AssessmentsSitesDestroyApiResponse = unknown;
export type ApiV1AssessmentsSitesDestroyApiArg = {
  /** A UUID string identifying this site. */
  id: string;
};
export type ApiV1AssessmentsSitesAllListApiResponse = /** status 200  */ SiteRead[];
export type ApiV1AssessmentsSitesAllListApiArg = void;
export type ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsListApiResponse =
  /** status 200  */ SiteWithAssignedAssessmentsWithStandardsForReportsRead[];
export type ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsListApiArg = {
  /** * `active` - Active
   * `completed` - Completed */
  assessmentStatus?: "active" | "completed";
  assessments?: string[];
  /** A search term. */
  search?: string;
  sites?: string[];
  standards?: number[];
};
export type ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsFiltersRetrieveApiResponse =
  /** status 200  */ SiteWithAssignedAssessmentsWithStandardsFiltersRead;
export type ApiV1AssessmentsSitesAssignedAssessmentsWithStandardsFiltersRetrieveApiArg = void;
export type ApiV1AssessmentsSitesFiltersRetrieveApiResponse = /** status 200  */ SiteFilters;
export type ApiV1AssessmentsSitesFiltersRetrieveApiArg = void;
export type ApiV1AssessmentsSitesImportCreateApiResponse = /** status 200  */ SiteRead;
export type ApiV1AssessmentsSitesImportCreateApiArg = {
  importSites: ImportSites;
};
export type ApiV1AssessmentsTasksProgressListApiResponse = /** status 200  */ SiteAssessmentWithTaskAmounts[];
export type ApiV1AssessmentsTasksProgressListApiArg = void;
export type ApiV1AssessmentsUpdatePanelAssessmentsRetrieveApiResponse = /** status 200  */ AssessmentUpdatePanelRead;
export type ApiV1AssessmentsUpdatePanelAssessmentsRetrieveApiArg = void;
export type ApiV1AssessmentsUpdatePanelAssessmentsDryRunRetrieveApiResponse = unknown;
export type ApiV1AssessmentsUpdatePanelAssessmentsDryRunRetrieveApiArg = {
  assessmentId: string;
  /** Report mode for the dry run. Defaults to 'STAKEHOLDER'. */
  reportMode?: "STAKEHOLDER" | "TECHNICAL";
};
export type ApiV1AssessmentsUpdatePanelAssessmentsHistoryRetrieveApiResponse = unknown;
export type ApiV1AssessmentsUpdatePanelAssessmentsHistoryRetrieveApiArg = {
  assessmentId: string;
  historyId: number;
  /** Report mode for the dry run. Defaults to 'STAKEHOLDER'. */
  reportMode?: "STAKEHOLDER" | "TECHNICAL";
};
export type ApiV1AssessmentsUpdatePanelAssessmentsUpdateCreateApiResponse =
  /** status 200  */ AssessmentUpdatePanelComparisonRead;
export type ApiV1AssessmentsUpdatePanelAssessmentsUpdateCreateApiArg = {
  assessmentId: string;
};
export type ApiV1BiExportListApiResponse = /** status 200  */ BiExportRead[];
export type ApiV1BiExportListApiArg = void;
export type ApiV1ConformityHeatmapDataListApiResponse = /** status 200  */ ConformityHeatmapDataPointRead[];
export type ApiV1ConformityHeatmapDataListApiArg = {
  /** Filter by assessment ID */
  assessment?: string;
  /** Filter by site ID */
  site?: string;
  /** Filter by applied standard ID */
  standard?: string;
  /** Filter by sub-theme ID */
  subTheme?: string;
  /** Filter by theme ID */
  theme?: string;
  /** Filter by year of first assessment step's due date */
  year?: number;
};
export type ApiV1ConformityHeatmapFiltersDataRetrieveApiResponse = /** status 200  */ ConformityHeatmapFiltersRead;
export type ApiV1ConformityHeatmapFiltersDataRetrieveApiArg = {
  /** Filter by assessment ID */
  assessment?: string;
  /** Filter by site ID */
  site?: string;
  /** Filter by applied standard ID */
  standard?: string;
  /** Filter by sub-theme ID */
  subTheme?: string;
  /** Filter by theme ID */
  theme?: string;
  /** Filter by year of first assessment step's due date */
  year?: number;
};
export type ApiV1CorporationsListApiResponse = /** status 200  */ CorporationRead[];
export type ApiV1CorporationsListApiArg = void;
export type ApiV1CorporationsCreateApiResponse = /** status 201  */ CorporationRead;
export type ApiV1CorporationsCreateApiArg = {
  corporation: Corporation;
};
export type ApiV1CorporationsRetrieveApiResponse = /** status 200  */ CorporationRead;
export type ApiV1CorporationsRetrieveApiArg = {
  /** A UUID string identifying this corporation. */
  id: string;
};
export type ApiV1CorporationsUpdateApiResponse = /** status 200  */ CorporationRead;
export type ApiV1CorporationsUpdateApiArg = {
  /** A UUID string identifying this corporation. */
  id: string;
  corporation: Corporation;
};
export type ApiV1CorporationsCleanupDestroyApiResponse = unknown;
export type ApiV1CorporationsCleanupDestroyApiArg = {
  id: string;
};
export type ApiV1CorporationsFlagsRetrieveApiResponse = /** status 200  */ CorporationFlags;
export type ApiV1CorporationsFlagsRetrieveApiArg = {
  /** A UUID string identifying this corporation. */
  id: string;
};
export type ApiV1CorporationsSimplifyListApiResponse = /** status 200  */ CorporationSimple[];
export type ApiV1CorporationsSimplifyListApiArg = void;
export type ApiV1DownloadRetrieveApiResponse = unknown;
export type ApiV1DownloadRetrieveApiArg = {
  /** UUID of the requested evidence */
  evidenceId: string;
};
export type ApiV1DownloadSiteAssessmentsAttachmentsRetrieveApiResponse = /** status 200  */ string;
export type ApiV1DownloadSiteAssessmentsAttachmentsRetrieveApiArg = {
  /** ID of the attachment to download */
  attachmentId: string;
  /** Type of process */
  processType: "approval" | "verification";
};
export type ApiV1NotificationsCurrentListApiResponse = /** status 200  */ NotificationRegistryRead[];
export type ApiV1NotificationsCurrentListApiArg = void;
export type ApiV1NotificationsProductCreateApiResponse = /** status 200  */ ProductNotificationRead;
export type ApiV1NotificationsProductCreateApiArg = {
  productNotification: ProductNotification;
};
export type ApiV1NotificationsThemeAssignedCreateApiResponse = /** status 200  */ Success;
export type ApiV1NotificationsThemeAssignedCreateApiArg = {
  isAdded: number;
  themeAssignedNotification: ThemeAssignedNotification;
};
export type ApiV1ProtocolSetsListApiResponse = /** status 200  */ ProtocolSetRead[];
export type ApiV1ProtocolSetsListApiArg = void;
export type ApiV1ProtocolSetsRetrieveApiResponse = /** status 200  */ ProtocolSetRead;
export type ApiV1ProtocolSetsRetrieveApiArg = {
  id: number;
};
export type ApiV1ProtocolSetsCleanupDestroyApiResponse = unknown;
export type ApiV1ProtocolSetsCleanupDestroyApiArg = {
  id: number;
};
export type ApiV1ProtocolSetsFiltersRetrieveApiResponse = /** status 200  */ ProtocolSetFiltersRead;
export type ApiV1ProtocolSetsFiltersRetrieveApiArg = {
  id: number;
};
export type ApiV1ProtocolSetsInterlinkCreateApiResponse = /** status 200  */ LinkManyResponseItem[];
export type ApiV1ProtocolSetsInterlinkCreateApiArg = {
  id: number;
  linkProtocolQuestions: LinkProtocolQuestions;
};
export type ApiV1ProtocolSetsProtocolQuestionCreateApiResponse = /** status 200  */ SimpleProtocolRead;
export type ApiV1ProtocolSetsProtocolQuestionCreateApiArg = {
  id: number;
  createProtocol: CreateProtocolWrite;
};
export type ApiV1ProtocolSetsProtocolQuestionsListApiResponse = /** status 200  */ PaginatedGetProtocolListRead;
export type ApiV1ProtocolSetsProtocolQuestionsListApiArg = {
  /** Full text search against protocol and requirement contents */
  ftSearch?: string;
  id: number;
  /** Ordering list using field name. Allowed fields: 'name'. You can use e.g. '-name' to reverse order. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of items per page. If set to 0, all items will be returned. */
  pageSize?: number;
  /** Allows to exclude protocol questions from the search */
  protocolQuestionNot?: number[];
  /** Allows to retrieve protocol questions, which are not linked to a requirement */
  requirementNot?: number;
  /** Filter by Standard id(s) */
  requirements?: number[];
  /** Filter by Scope of applicability id(s) */
  scopeOfApplicability?: number[];
  /** Simple text search using Django SearchFilter against name, theme__name, sub_theme__name and reference names */
  search?: string;
  /** A value between 0 - 1, which represents a trigram similarity score. Acts as an additional way to include results if full text search doesn't match */
  searchScoreThreshold?: number;
  /** Filter by Sub Theme ID(s) */
  subTheme?: number[];
  /** Filter by Theme ID(s) */
  theme?: number[];
};
export type ApiV1ProtocolSetsProtocolQuestionsDownloadMappingXlsxRetrieveApiResponse =
  /** status 200  */ GetProtocolRead;
export type ApiV1ProtocolSetsProtocolQuestionsDownloadMappingXlsxRetrieveApiArg = {
  id: number;
};
export type ApiV1ProtocolSetsProtocolQuestionsDownloadXlsxRetrieveApiResponse = /** status 200  */ Blob;
export type ApiV1ProtocolSetsProtocolQuestionsDownloadXlsxRetrieveApiArg = {
  /** Return only specified columns */
  column?: string[];
  /** Full Text Search query */
  ftSearch?: string;
  id: number;
  /** Ordering list using field name. Allowed fields: 'name'. You can use e.g. '-name' to reverse order. */
  ordering?: string;
  /** Filter by Standard id(s) */
  requirements?: number[];
  /** Filter by Scope of Applicabilit(y|ies) */
  scopeOfApplicability?: number[];
  /** Search by query */
  search?: string;
  /** Filter by Sub Theme ID(s) */
  subTheme?: number[];
  /** Filter by Theme ID(s) */
  theme?: number[];
};
export type ApiV1ProtocolSetsProtocolQuestionsSmartSemanticSearchListApiResponse =
  /** status 200  */ GetProtocolSimilarityScoreRead[];
export type ApiV1ProtocolSetsProtocolQuestionsSmartSemanticSearchListApiArg = {
  id: number;
  /** Return a subset of matches */
  limit?: number;
  /** Allows to exclude protocol questions from the search */
  protocolQuestionNot?: number[];
  /** Allows to retrieve protocol questions, which are not linked to a requirement */
  requirementNot?: number;
  requirements?: string[];
  scopeOfApplicability?: string[];
  /** Search value for similarity threshold */
  search: string;
  /** Similarity threshold, range 0-100 */
  similarityThreshold: number;
  /** Filter by Sub Theme ID */
  subTheme?: number[];
  /** Filter by Theme ID */
  theme?: number[];
};
export type ApiV1ProtocolSetsPublishCreateApiResponse = /** status 200  */ ProtocolSetRead;
export type ApiV1ProtocolSetsPublishCreateApiArg = {
  id: number;
};
export type ApiV1ProtocolSetsSetToReviewCreateApiResponse = /** status 200  */ ProtocolSetRead;
export type ApiV1ProtocolSetsSetToReviewCreateApiArg = {
  id: number;
};
export type ApiV1ProtocolSetsCompareListApiResponse = /** status 200  */ ProtocolSetComparisonOutput[];
export type ApiV1ProtocolSetsCompareListApiArg = {
  /** Id of **left** Protocol Set */
  leftId?: number;
  /** Format of response */
  responseFormat: "JSON" | "xlsx";
  /** Id of **right** Protocol Set */
  rightId?: number;
};
export type ApiV1ProtocolSetsCreateDraftCreateApiResponse = /** status 200  */ ProtocolSetRead;
export type ApiV1ProtocolSetsCreateDraftCreateApiArg = {
  protocolSetSerializerCreateDraft: ProtocolSetSerializerCreateDraft;
};
export type ApiV1ProtocolSetsLatestOrDraftRetrieveApiResponse = /** status 200  */ ProtocolSetRead;
export type ApiV1ProtocolSetsLatestOrDraftRetrieveApiArg = void;
export type ApiV1ReportsAssessmentsSiteAssessmentsListApiResponse =
  /** status 200  */ PaginatedReportAssessmentListRead;
export type ApiV1ReportsAssessmentsSiteAssessmentsListApiArg = {
  assessmentId: string;
  /** Return only rows with given conformity levels */
  conformityLevel?: string[];
  /** Returns true if Internal Audit is required false otherwise */
  internalAuditRequired?: string[];
  /** Sorting results data by field. Prefix '-' will sort descending. */
  order?:
    | "-conformity_level"
    | "-internal_audit_required"
    | "-protocol_id"
    | "-stakeholder_approval_required"
    | "-standard_references"
    | "-status"
    | "-sub_theme"
    | "-theme"
    | "conformity_level"
    | "internal_audit_required"
    | "protocol_id"
    | "stakeholder_approval_required"
    | "standard_references"
    | "status"
    | "sub_theme"
    | "theme";
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Search by query */
  query?: string;
  siteAssessmentId: string;
  /** Returns true if stakeholder approval is required false otherwise */
  stakeholderApprovalRequired?: string[];
  /** Return only rows with given standard */
  standardReferences?: string[];
  /** Return only rows with given statuses */
  status?: string[];
  /** Return only rows with given sub themes */
  subTheme?: string[];
  /** Return only rows with given themes */
  theme?: string[];
};
export type ApiV1ReportsAssessmentsSiteAssessmentsDownloadCsvRetrieveApiResponse =
  /** status 200  */ ReportAssessmentRead;
export type ApiV1ReportsAssessmentsSiteAssessmentsDownloadCsvRetrieveApiArg = {
  assessmentId: string;
  /** Return only given columns with order */
  column?: string[];
  /** Return only rows with given conformity levels */
  conformityLevel?: string[];
  /** Returns true if Internal Audit is required false otherwise */
  internalAuditRequired?: string[];
  /** Sorting results data by field. Prefix '-' will sort descending. */
  order?:
    | "-conformity_level"
    | "-internal_audit_required"
    | "-protocol_id"
    | "-stakeholder_approval_required"
    | "-standard_references"
    | "-status"
    | "-sub_theme"
    | "-theme"
    | "conformity_level"
    | "internal_audit_required"
    | "protocol_id"
    | "stakeholder_approval_required"
    | "standard_references"
    | "status"
    | "sub_theme"
    | "theme";
  /** Search by query */
  query?: string;
  siteAssessmentId: string;
  /** Returns true if stakeholder approval is required false otherwise */
  stakeholderApprovalRequired?: string[];
  /** Return only rows with given standard */
  standardReferences?: string[];
  /** Return only rows with given statuses */
  status?: string[];
  /** Return only rows with given sub themes */
  subTheme?: string[];
  /** Return only rows with given themes */
  theme?: string[];
};
export type ApiV1ReportsAssessmentsSiteAssessmentsDownloadXlsxRetrieveApiResponse =
  /** status 200  */ ReportAssessmentRead;
export type ApiV1ReportsAssessmentsSiteAssessmentsDownloadXlsxRetrieveApiArg = {
  assessmentId: string;
  /** Return only given columns with order */
  column?: string[];
  /** Return only rows with given conformity levels */
  conformityLevel?: string[];
  /** Returns true if Internal Audit is required false otherwise */
  internalAuditRequired?: string[];
  /** Sorting results data by field. Prefix '-' will sort descending. */
  order?:
    | "-conformity_level"
    | "-internal_audit_required"
    | "-protocol_id"
    | "-stakeholder_approval_required"
    | "-standard_references"
    | "-status"
    | "-sub_theme"
    | "-theme"
    | "conformity_level"
    | "internal_audit_required"
    | "protocol_id"
    | "stakeholder_approval_required"
    | "standard_references"
    | "status"
    | "sub_theme"
    | "theme";
  /** Search by query */
  query?: string;
  siteAssessmentId: string;
  /** Returns true if stakeholder approval is required false otherwise */
  stakeholderApprovalRequired?: string[];
  /** Return only rows with given standard */
  standardReferences?: string[];
  /** Return only rows with given statuses */
  status?: string[];
  /** Return only rows with given sub themes */
  subTheme?: string[];
  /** Return only rows with given themes */
  theme?: string[];
};
export type ApiV1ReportsAssessmentsSiteAssessmentsFiltersRetrieveApiResponse =
  /** status 200  */ ReportAssessmentFilters;
export type ApiV1ReportsAssessmentsSiteAssessmentsFiltersRetrieveApiArg = {
  assessmentId: string;
  siteAssessmentId: string;
};
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaRetrieveApiResponse = /** status 200  */ IrmaReport;
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaRetrieveApiArg = {
  assessmentId: string;
  siteAssessmentId: string;
  standardId: number;
};
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaXlsxRetrieveApiResponse = /** status 200  */ IrmaReport;
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaXlsxRetrieveApiArg = {
  assessmentId: string;
  siteAssessmentId: string;
  standardId: number;
};
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupListApiResponse =
  /** status 200  */ PaginatedReportStandardList;
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupListApiArg = {
  /** The level of roll-up aggregation to apply to */
  aggregateLevel?: "requirement" | "section" | "sub_section";
  assessmentId: string;
  /** Return only rows with given conformity levels */
  conformityLevel?: ("2" | "3" | "4" | "5" | "99" | "blank")[];
  isRollup: number;
  /** Sorting results data by field. Prefix '-' will sort descending. */
  order?:
    | "-conformity_level"
    | "-reference"
    | "-requirement"
    | "-section"
    | "-section_ref"
    | "-sub_section"
    | "-sub_section_ref"
    | "conformity_level"
    | "reference"
    | "requirement"
    | "section"
    | "section_ref"
    | "sub_section"
    | "sub_section_ref";
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** Search by query */
  query?: string;
  /** Return only rows with given sections */
  section?: string[];
  siteAssessmentId: string;
  standardId: number;
  /** Return only rows with given sub-sections */
  subSection?: string[];
};
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadCsvRetrieveApiResponse =
  /** status 200  */ ReportStandard;
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadCsvRetrieveApiArg = {
  /** The level of roll-up aggregation to apply to */
  aggregateLevel?: "requirement" | "section" | "sub_section";
  assessmentId: string;
  /** Return only given columns with order */
  column?: string[];
  /** Return only rows with given conformity levels */
  conformityLevel?: ("2" | "3" | "4" | "5" | "99" | "blank")[];
  isRollup: number;
  /** Sorting results data by field. Prefix '-' will sort descending. */
  order?:
    | "-conformity_level"
    | "-reference"
    | "-requirement"
    | "-section"
    | "-section_ref"
    | "-sub_section"
    | "-sub_section_ref"
    | "conformity_level"
    | "reference"
    | "requirement"
    | "section"
    | "section_ref"
    | "sub_section"
    | "sub_section_ref";
  /** Search by query */
  query?: string;
  /** Return only rows with given sections */
  section?: string[];
  siteAssessmentId: string;
  standardId: number;
  /** Return only rows with given sub-sections */
  subSection?: string[];
};
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadXlsxRetrieveApiResponse =
  /** status 200  */ ReportStandard;
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadXlsxRetrieveApiArg = {
  /** The level of roll-up aggregation to apply to */
  aggregateLevel?: "requirement" | "section" | "sub_section";
  assessmentId: string;
  /** Return only given columns with order */
  column?: string[];
  /** Return only rows with given conformity levels */
  conformityLevel?: ("2" | "3" | "4" | "5" | "99" | "blank")[];
  isRollup: number;
  /** Sorting results data by field. Prefix '-' will sort descending. */
  order?:
    | "-conformity_level"
    | "-reference"
    | "-requirement"
    | "-section"
    | "-section_ref"
    | "-sub_section"
    | "-sub_section_ref"
    | "conformity_level"
    | "reference"
    | "requirement"
    | "section"
    | "section_ref"
    | "sub_section"
    | "sub_section_ref";
  /** Search by query */
  query?: string;
  /** Return only rows with given sections */
  section?: string[];
  siteAssessmentId: string;
  standardId: number;
  /** Return only rows with given sub-sections */
  subSection?: string[];
};
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupFiltersRetrieveApiResponse =
  /** status 200  */ ReportStandardFilters;
export type ApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupFiltersRetrieveApiArg = {
  assessmentId: string;
  isRollup: number;
  siteAssessmentId: string;
  standardId: number;
};
export type ApiV1ReportsCustomListApiResponse = /** status 200  */ CustomReportReadRead[];
export type ApiV1ReportsCustomListApiArg = {
  /** * `active` - Active
   * `completed` - Completed */
  assessmentStatus?: "active" | "completed";
  assessments?: string[];
  /** A search term. */
  search?: string;
  sites?: string[];
  standards?: number[];
};
export type ApiV1ReportsCustomCreateApiResponse = /** status 201  */ CustomReportCreate;
export type ApiV1ReportsCustomCreateApiArg = {
  customReportCreate: CustomReportCreate;
};
export type ApiV1ReportsCustomRetrieveApiResponse = /** status 200  */ CustomReportReadRead;
export type ApiV1ReportsCustomRetrieveApiArg = {
  /** A unique integer value identifying this custom report. */
  id: number;
};
export type ApiV1ReportsCustomPartialUpdateApiResponse = /** status 200  */ CustomReportPartialUpdate;
export type ApiV1ReportsCustomPartialUpdateApiArg = {
  /** A unique integer value identifying this custom report. */
  id: number;
  patchedCustomReportPartialUpdate: PatchedCustomReportPartialUpdate;
};
export type ApiV1ReportsCustomDestroyApiResponse = unknown;
export type ApiV1ReportsCustomDestroyApiArg = {
  /** A unique integer value identifying this custom report. */
  id: number;
};
export type ApiV1ReportsCustomDownloadCsvRetrieveApiResponse = unknown;
export type ApiV1ReportsCustomDownloadCsvRetrieveApiArg = {
  /** Return only given columns with order */
  columns?: string[];
  /** Return only rows with given aggregate conformity level */
  conformityLevel?: string[];
  /** Return only rows with given references */
  reference?: string[];
  reportId: number;
  /** Search by query */
  search?: string;
  /** Return only rows with given sections */
  section?: string[];
  /** Return only rows with given standard names */
  standardName?: string[];
  /** Return only rows with given sub-sections */
  subSection?: string[];
};
export type ApiV1ReportsCustomDownloadXlsxRetrieveApiResponse = unknown;
export type ApiV1ReportsCustomDownloadXlsxRetrieveApiArg = {
  /** Return only given columns with order */
  columns?: string[];
  /** Return only rows with given aggregate conformity level */
  conformityLevel?: string[];
  /** Return only rows with given references */
  reference?: string[];
  reportId: number;
  /** Search by query */
  search?: string;
  /** Return only rows with given sections */
  section?: string[];
  /** Return only rows with given standard names */
  standardName?: string[];
  /** Return only rows with given sub-sections */
  subSection?: string[];
};
export type ApiV1CustomReportFiltersDetailApiResponse = /** status 200  */ CustomReportGeneratedDataFilters;
export type ApiV1CustomReportFiltersDetailApiArg = {
  reportId: number;
};
export type ApiV1ReportsCustomGetDataRetrieveApiResponse = /** status 200  */ CustomReportGeneratedDataResponse;
export type ApiV1ReportsCustomGetDataRetrieveApiArg = {
  /** Return only rows with given aggregate conformity level */
  conformityLevel?: string[];
  /** Return only rows with given references */
  reference?: string[];
  reportId: number;
  /** Search by query */
  search?: string;
  /** Return only rows with given sections */
  section?: string[];
  /** Return only rows with given standard names */
  standardName?: string[];
  /** Return only rows with given sub-sections */
  subSection?: string[];
};
export type ApiV1ReportsCustomFiltersRetrieveApiResponse = /** status 200  */ CustomReportListFiltersRead;
export type ApiV1ReportsCustomFiltersRetrieveApiArg = void;
export type ApiV1ScopesOfApplicabilityListApiResponse = /** status 200  */ ScopeOfApplicabilityRead[];
export type ApiV1ScopesOfApplicabilityListApiArg = void;
export type ApiV1StandardsProtocolsRetrieveApiResponse = /** status 200  */ GetSingleProtocolRead;
export type ApiV1StandardsProtocolsRetrieveApiArg = {
  /** A unique integer value identifying this protocol question. */
  id: number;
};
export type ApiV1StandardsProtocolsUpdateApiResponse = /** status 200  */ CreateProtocolRead;
export type ApiV1StandardsProtocolsUpdateApiArg = {
  /** A unique integer value identifying this protocol question. */
  id: number;
  createProtocol: CreateProtocolWrite;
};
export type ApiV1StandardsProtocolsPartialUpdateApiResponse = /** status 200  */ CreateProtocolRead;
export type ApiV1StandardsProtocolsPartialUpdateApiArg = {
  /** A unique integer value identifying this protocol question. */
  id: number;
  patchedCreateProtocol: PatchedCreateProtocolWrite;
};
export type ApiV1StandardsProtocolsDestroyApiResponse = unknown;
export type ApiV1StandardsProtocolsDestroyApiArg = {
  /** A unique integer value identifying this protocol question. */
  id: number;
};
export type ApiV1StandardsProtocolsDuplicateCreateApiResponse = /** status 200  */ GetProtocolRead;
export type ApiV1StandardsProtocolsDuplicateCreateApiArg = {
  /** A unique integer value identifying this protocol question. */
  id: number;
};
export type ApiV1StandardsProtocolsRelatedProtocolsListApiResponse = /** status 200  */ GetProtocolRead[];
export type ApiV1StandardsProtocolsRelatedProtocolsListApiArg = {
  id: number;
};
export type ApiV1StandardsProtocolsRelatedProtocolsCreateApiResponse = unknown;
export type ApiV1StandardsProtocolsRelatedProtocolsCreateApiArg = {
  id: number;
  linkProtocolQuestions: LinkProtocolQuestions;
};
export type ApiV1StandardsProtocolsRelatedProtocolsDestroyApiResponse = unknown;
export type ApiV1StandardsProtocolsRelatedProtocolsDestroyApiArg = {
  id: number;
  relatedProtocolId: number;
};
export type ApiV1StandardsProtocolsShowHistoryListApiResponse = /** status 200  */ ProtocolQuestionHistory[];
export type ApiV1StandardsProtocolsShowHistoryListApiArg = {
  /** A unique integer value identifying this protocol question. */
  id: number;
};
export type ApiV1StandardsProtocolsReorderCreateApiResponse = unknown;
export type ApiV1StandardsProtocolsReorderCreateApiArg = {
  protocolQuestionReorder: ProtocolQuestionReorder;
};
export type ApiV1StandardsRequirementsListApiResponse = /** status 200  */ PaginatedRequirementLinkingListListRead;
export type ApiV1StandardsRequirementsListApiArg = {
  /** List only requirements having a relation to an existing protocol question */
  isMapped?: boolean;
  /** Ordering list using field name. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Retrieve only the protocol questions linked to requirements that belong to the given protocol set. */
  prefetchProtocolSetId?: number;
  /** List only requirements that are related to the given protocol. */
  protocol?: number;
  /** List only requirements that are not related to the given protocol. */
  protocolNot?: number;
  questions?: number[];
  /** Lexical search by content or reference. */
  search?: string;
  /** List only requirements that are related to a given standards. */
  standard?: number[];
};
export type ApiV1StandardsRequirementsCreateApiResponse = /** status 201  */ RequirementWriteOutputRead;
export type ApiV1StandardsRequirementsCreateApiArg = {
  requirementWrite: RequirementWrite;
};
export type ApiV1StandardsRequirementsRetrieveApiResponse = /** status 200  */ RequirementLinkingListRead;
export type ApiV1StandardsRequirementsRetrieveApiArg = {
  id: number;
};
export type ApiV1StandardsRequirementsUpdateApiResponse = /** status 200  */ RequirementWriteOutputRead;
export type ApiV1StandardsRequirementsUpdateApiArg = {
  id: number;
  requirementWrite: RequirementWrite;
};
export type ApiV1StandardsRequirementsPartialUpdateApiResponse = /** status 200  */ RequirementWriteOutputRead;
export type ApiV1StandardsRequirementsPartialUpdateApiArg = {
  id: number;
  patchedRequirementWrite: PatchedRequirementWrite;
};
export type ApiV1StandardsRequirementsDestroyApiResponse = unknown;
export type ApiV1StandardsRequirementsDestroyApiArg = {
  id: number;
};
export type ApiV1StandardsRequirementsFiltersRetrieveApiResponse = /** status 200  */ RequirementFiltersRead;
export type ApiV1StandardsRequirementsFiltersRetrieveApiArg = void;
export type ApiV1StandardsRequirementsLinkProtocolQuestionsCreateApiResponse = unknown;
export type ApiV1StandardsRequirementsLinkProtocolQuestionsCreateApiArg = {
  linkProtocolQuestion: LinkProtocolQuestion;
};
export type ApiV1StandardsRequirementsLinkToProtocolQuestionCreateApiResponse = unknown;
export type ApiV1StandardsRequirementsLinkToProtocolQuestionCreateApiArg = {
  linkRequirement: LinkRequirement;
};
export type ApiV1StandardsRequirementsLiteListApiResponse =
  /** status 200  */ PaginatedHighlightedRequirementSectionListRead;
export type ApiV1StandardsRequirementsLiteListApiArg = {
  isMapped?: boolean;
  /** A page number within the paginated result set. */
  page?: number;
  protocol?: string;
  /** List only requirements that are not related to the given protocol. */
  protocolNot?: number;
  questions?: number[];
  /** Full text search + similarity against requirements content, name and a regular search for reference */
  search?: string;
  /** A value between 0 - 1, which represents a trigram similarity score. Acts as an additional way to include results if full text search doesn't match */
  searchScoreThreshold?: number;
  standard?: number[];
};
export type ApiV1StandardsRequirementsSmartSemanticSearchListApiResponse =
  /** status 200  */ RequirementLinkingListSimilarityScoreRead[];
export type ApiV1StandardsRequirementsSmartSemanticSearchListApiArg = {
  /** List only requirements having a relation to an existing protocol question */
  isMapped?: boolean;
  /** Return a subset of matches */
  limit?: number;
  protocol?: string;
  /** List only requirements that are not related to the given protocol. */
  protocolNot?: number;
  questions?: number[];
  /** Search value for similarity threshold */
  search: string;
  /** Similarity threshold, range 0-100 */
  similarityThreshold: number;
  /** List only requirements that are related to a given standard. */
  standard?: number[];
};
export type ApiV1StandardsRequirementsUnlinkFromProtocolQuestionCreateApiResponse = unknown;
export type ApiV1StandardsRequirementsUnlinkFromProtocolQuestionCreateApiArg = {
  linkRequirement: LinkRequirement;
};
export type ApiV1StandardsStandardGuidanceListApiResponse = /** status 200  */ StandardGuidanceListRead[];
export type ApiV1StandardsStandardGuidanceListApiArg = {
  /** A search term. */
  search?: string;
  standard?: number;
  /** * `note` - Clarifying Notes
   * `verification` - Means of Verification
   * `evidence` - Evidence Examples */
  type?: "evidence" | "note" | "verification";
};
export type ApiV1StandardsStandardGuidanceCreateApiResponse = /** status 201  */ StandardGuidanceRead;
export type ApiV1StandardsStandardGuidanceCreateApiArg = {
  standardGuidance: StandardGuidance;
};
export type ApiV1StandardsStandardGuidanceRetrieveApiResponse = /** status 200  */ StandardGuidanceRead;
export type ApiV1StandardsStandardGuidanceRetrieveApiArg = {
  /** A unique integer value identifying this standard guidance. */
  id: number;
};
export type ApiV1StandardsStandardGuidanceUpdateApiResponse = /** status 200  */ StandardGuidanceRead;
export type ApiV1StandardsStandardGuidanceUpdateApiArg = {
  /** A unique integer value identifying this standard guidance. */
  id: number;
  standardGuidance: StandardGuidance;
};
export type ApiV1StandardsStandardGuidancePartialUpdateApiResponse = /** status 200  */ StandardGuidanceRead;
export type ApiV1StandardsStandardGuidancePartialUpdateApiArg = {
  /** A unique integer value identifying this standard guidance. */
  id: number;
  patchedStandardGuidance: PatchedStandardGuidance;
};
export type ApiV1StandardsStandardGuidanceDestroyApiResponse = unknown;
export type ApiV1StandardsStandardGuidanceDestroyApiArg = {
  /** A unique integer value identifying this standard guidance. */
  id: number;
};
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateApiResponse = unknown;
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateApiArg = {
  linkStandardGuidance: LinkStandardGuidance;
};
export type ApiV1StandardsStandardGuidanceUnlinkFromRequirementCreateApiResponse = unknown;
export type ApiV1StandardsStandardGuidanceUnlinkFromRequirementCreateApiArg = {
  linkStandardGuidance: LinkStandardGuidance;
};
export type ApiV1StandardsStandardsListApiResponse = /** status 200  */ StandardExtendedRead[];
export type ApiV1StandardsStandardsListApiArg = {
  /** Ordering list using field name. Allowed fields: 'full_name', 'body', 'name', 'published_date'. You can use e.g. '-name' to reverse order. */
  ordering?: string;
  publishedDate?: string;
  publishedDateGt?: string;
  publishedDateLt?: string;
  /** A search term. */
  search?: string;
  /** Set to 'true' to show all Standards, regardless of Tenant. Usable for SME and Super Admins only. */
  showAll?: boolean;
  tenants?: string[];
  /** Set to 'true' to list global Standards */
  tenantsIsnull?: boolean;
  version?: string;
};
export type ApiV1StandardsStandardsCreateApiResponse = /** status 201  */ StandardRead;
export type ApiV1StandardsStandardsCreateApiArg = {
  standard: Standard;
};
export type ApiV1StandardsStandardsRetrieveApiResponse = /** status 200  */ StandardExtendedRead;
export type ApiV1StandardsStandardsRetrieveApiArg = {
  /** A unique integer value identifying this standard. */
  id: number;
};
export type ApiV1StandardsStandardsUpdateApiResponse = /** status 200  */ StandardRead;
export type ApiV1StandardsStandardsUpdateApiArg = {
  /** A unique integer value identifying this standard. */
  id: number;
  standard: Standard;
};
export type ApiV1StandardsStandardsPartialUpdateApiResponse = /** status 200  */ StandardRead;
export type ApiV1StandardsStandardsPartialUpdateApiArg = {
  /** A unique integer value identifying this standard. */
  id: number;
  patchedStandard: PatchedStandard;
};
export type ApiV1StandardsStandardsDestroyApiResponse = unknown;
export type ApiV1StandardsStandardsDestroyApiArg = {
  /** A unique integer value identifying this standard. */
  id: number;
};
export type ApiV1StandardsStandardsSectionsListApiResponse = /** status 200  */ SectionWithSubSectionRead[];
export type ApiV1StandardsStandardsSectionsListApiArg = {
  standardId: number;
};
export type ApiV1StandardsStandardsSectionsCreateApiResponse = /** status 200  */ SectionRead;
export type ApiV1StandardsStandardsSectionsCreateApiArg = {
  standardId: number;
  sectionCreate: SectionCreate;
};
export type ApiV1StandardsStandardsSectionsCreate2ApiResponse = /** status 200  */ SectionRead;
export type ApiV1StandardsStandardsSectionsCreate2ApiArg = {
  sectionId: number;
  standardId: number;
  sectionCreate: SectionCreate;
};
export type ApiV1StandardsStandardsSectionsUpdateApiResponse = /** status 200  */ SectionRead;
export type ApiV1StandardsStandardsSectionsUpdateApiArg = {
  sectionId: number;
  standardId: number;
  sectionCreate: SectionCreate;
};
export type ApiV1StandardsStandardsSectionsDestroyApiResponse = unknown;
export type ApiV1StandardsStandardsSectionsDestroyApiArg = {
  sectionId: number;
  standardId: number;
};
export type ApiV1StandardsStandardsFiltersRetrieveApiResponse = /** status 200  */ StandardsFilter;
export type ApiV1StandardsStandardsFiltersRetrieveApiArg = {
  /** Set to 'true' to show filters for all Standards, regardless of Tenant. Usable for SME and Super Admins only. */
  showAll?: boolean;
};
export type ApiV1StandardsSubthemesListApiResponse = /** status 200  */ SubThemeRead[];
export type ApiV1StandardsSubthemesListApiArg = {
  /** Ordering list using field name. Allowed fields: 'name'. You can use e.g. '-name' to reverse order. */
  ordering?: string;
};
export type ApiV1StandardsThemesListApiResponse = /** status 200  */ ThemeRead[];
export type ApiV1StandardsThemesListApiArg = {
  /** Ordering list using field name. Allowed fields: 'name'. You can use e.g. '-name' to reverse order. */
  ordering?: string;
};
export type ApiV1UploadRetrieveApiResponse = /** status 200  */ UploadResponse;
export type ApiV1UploadRetrieveApiArg = {
  /** object name for upload */
  objName: string;
};
export type ApiV1UserManagementListApiResponse = /** status 200  */ PaginatedUserManagementListRead;
export type ApiV1UserManagementListApiArg = {
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
  /** A search term. */
  search?: string;
  /** * `I` - Invited
   * `A` - Active
   * `D` - Deactivated
   * `E` - Invitation expired */
  userStatus?: ("A" | "D" | "E" | "I")[];
};
export type ApiV1UserManagementCreateApiResponse = /** status 201  */ UserManagementRead;
export type ApiV1UserManagementCreateApiArg = {
  userManagement: UserManagement;
};
export type ApiV1UserManagementRetrieveApiResponse = /** status 200  */ UserManagementRead;
export type ApiV1UserManagementRetrieveApiArg = {
  /** A UUID string identifying this user. */
  id: string;
};
export type ApiV1UserManagementUpdateApiResponse = /** status 200  */ UserManagementRead;
export type ApiV1UserManagementUpdateApiArg = {
  /** A UUID string identifying this user. */
  id: string;
  userManagement: UserManagement;
};
export type ApiV1UserManagementDestroyApiResponse = unknown;
export type ApiV1UserManagementDestroyApiArg = {
  /** A UUID string identifying this user. */
  id: string;
};
export type ApiV1UserManagementDeactivateCreateApiResponse = /** status 200  */ UserManagementActionSuccess;
export type ApiV1UserManagementDeactivateCreateApiArg = {
  /** A UUID string identifying this user. */
  id: string;
};
export type ApiV1UserManagementReactivateCreateApiResponse = /** status 200  */ UserManagementActionSuccess;
export type ApiV1UserManagementReactivateCreateApiArg = {
  /** A UUID string identifying this user. */
  id: string;
};
export type ApiV1UserManagementReinviteCreateApiResponse = /** status 200  */ UserManagementActionSuccess;
export type ApiV1UserManagementReinviteCreateApiArg = {
  /** A UUID string identifying this user. */
  id: string;
};
export type ApiV1UserManagementResetMfaCreateApiResponse = /** status 200  */ UserManagementActionSuccess;
export type ApiV1UserManagementResetMfaCreateApiArg = {
  /** A UUID string identifying this user. */
  id: string;
};
export type ApiV1UserManagementResetPasswordCreateApiResponse = /** status 200  */ UserManagementActionSuccess;
export type ApiV1UserManagementResetPasswordCreateApiArg = {
  /** A UUID string identifying this user. */
  id: string;
};
export type ApiV1UserManagementFiltersRetrieveApiResponse = /** status 200  */ UserManagementFilters;
export type ApiV1UserManagementFiltersRetrieveApiArg = void;
export type ApiV1UserManagementInviteAdminCreateApiResponse = /** status 201  */ UserManagementBaseRead;
export type ApiV1UserManagementInviteAdminCreateApiArg = {
  userManagementBase: UserManagementBase;
};
export type ApiV1UserManagementProfileUpdateApiResponse = /** status 200  */ UserProfile;
export type ApiV1UserManagementProfileUpdateApiArg = {
  userProfile: UserProfile;
};
export type ApiV1UserPreferencesListApiResponse = /** status 200  */ UserPreferenceRead[];
export type ApiV1UserPreferencesListApiArg = void;
export type ApiV1UserPreferencesRetrieveApiResponse = /** status 200  */ UserPreferenceRead;
export type ApiV1UserPreferencesRetrieveApiArg = {
  tableName: string;
};
export type ApiV1UserPreferencesUpdateApiResponse = unknown;
export type ApiV1UserPreferencesUpdateApiArg = {
  /** Table for which we update preferences. */
  tableName: string;
  userPreference: UserPreference;
};
export type ApiV1UsersListApiResponse = /** status 200  */ UserRead[];
export type ApiV1UsersListApiArg = {
  /** Exclude users in these groups, comma-separated */
  excludedGroups?: string;
  /** User group name */
  group?: string;
  /** Ordering list using field name. Accepted fields: 'first_name', 'last_name'. You can use '-' to reverse ordering. You can use different fields joining they by ',' e.g. 'last_name,first_name'. */
  ordering?: string;
};
export type WhoamiRetrieveApiResponse = /** status 200  */ WhoAmIRead;
export type WhoamiRetrieveApiArg = void;
export type MappingJobProgress = {
  id: number;
  status: string;
  progress: any;
  error?: string | null;
};
export type MappingJob = {};
export type JobTypeEnum = "DUMP" | "LOAD";
export type MappingJobStatusEnum = "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED";
export type MappingJobRead = {
  id: number;
  user_email: string;
  job_type: JobTypeEnum;
  status: MappingJobStatusEnum;
  progress: any;
  error: string | null;
  created_at: string;
  completed_at: string | null;
};
export type SiteAssessmentThemeProgress = {
  theme_id: string;
  theme_name: string;
  theme_short_name: string | null;
  unassigned_amount: number;
  in_draft_unanswered_amount: number;
  in_draft_answered_amount: number;
  declined_amount: number;
  in_review_amount: number;
  reviewed_amount: number;
  total_amount: number;
};
export type SiteWithCoordinator = {
  name: string;
  country: string;
  type: number;
};
export type User = {
  first_name?: string;
  last_name?: string;
  email: string;
};
export type UserRead = {
  id: string;
  first_name?: string;
  last_name?: string;
  email: string;
};
export type SiteWithCoordinatorRead = {
  id: string;
  name: string;
  coordinator: UserRead;
  country: string;
  type: number;
};
export type Standard = {
  body?: string | null;
  name: string;
  full_name: string;
  version: string;
  requirement_corpus_link?: string;
  published_date?: string | null;
  tenants?: string[];
};
export type StandardRead = {
  id: number;
  body?: string | null;
  name: string;
  full_name: string;
  version: string;
  requirement_corpus_link?: string;
  published_date?: string | null;
  tenants?: string[];
};
export type SiteAssessmentSetWithStandards = {
  site: string;
  siteassessmentapproval: number;
  siteassessmentverification: number;
  assigned_themes?: any;
  applied_standards: Standard[];
};
export type SiteAssessmentSetWithStandardsRead = {
  id: string;
  site: string;
  siteassessmentapproval: number;
  siteassessmentverification: number;
  assigned_themes?: any;
  applied_standards: StandardRead[];
};
export type AssessmentRetrieve = {
  name?: string | null;
  applied_sites: SiteWithCoordinator[];
  final_submission_date?: string | null;
  applied_themes?: any;
  completed_at?: string | null;
  siteassessment_set: SiteAssessmentSetWithStandards[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  has_latest_protocol_set?: boolean;
};
export type StepsField = {
  role: string;
  due_date: string;
  step_id: number;
  step_order: number;
  name: string;
  description: string;
  assignments_count: number;
};
export type SiteBasicCoordinator = {
  name: string;
  coordinator?: string | null;
};
export type SiteBasicCoordinatorRead = {
  id: string;
  name: string;
  coordinator?: string | null;
};
export type Assessment = {
  name?: string | null;
  applied_sites: SiteBasicCoordinator[];
  final_submission_date?: string | null;
  applied_themes?: any;
  completed_at?: string | null;
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
};
export type SiteAssessmentSet = {
  site: string;
  assigned_themes?: any;
};
export type SiteAssessmentSetRead = {
  id: string;
  site: string;
  siteassessmentapproval: number | null;
  siteassessmentverification: number | null;
  assigned_themes?: any;
};
export type AssessmentRead = {
  id: string;
  name?: string | null;
  applied_sites: SiteBasicCoordinatorRead[];
  final_submission_date?: string | null;
  reviewers: UserRead[];
  applied_themes?: any;
  completed: boolean;
  completed_at?: string | null;
  steps: StepsField[];
  verifiers: UserRead[];
  siteassessment_set: SiteAssessmentSetRead[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  is_favorite: boolean;
};
export type AssessmentSiteWithStandards = {
  site_id?: string;
  standards?: number[];
};
export type AssessmentWrite = {
  name?: string | null;
  applied_sites: SiteBasicCoordinator[];
  final_submission_date?: string | null;
  applied_themes?: any;
  standards_per_site: AssessmentSiteWithStandards[];
  completed_at?: string | null;
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
};
export type AssessmentRetrieveRead = {
  id: string;
  name?: string | null;
  applied_sites: SiteWithCoordinatorRead[];
  final_submission_date?: string | null;
  reviewers: UserRead[];
  applied_themes?: any;
  completed: boolean;
  completed_at?: string | null;
  steps: StepsField[];
  verifiers: UserRead[];
  siteassessment_set: SiteAssessmentSetWithStandardsRead[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  is_favorite: boolean;
  assigned_cc: UserRead;
  has_latest_protocol_set?: boolean;
  source_assessment: AssessmentRead | null;
};
export type AssessmentRetrieveWrite = {
  name?: string | null;
  applied_sites: SiteWithCoordinator[];
  final_submission_date?: string | null;
  applied_themes?: any;
  standards_per_site: AssessmentSiteWithStandards[];
  completed_at?: string | null;
  siteassessment_set: SiteAssessmentSetWithStandards[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  has_latest_protocol_set?: boolean;
};
export type PaginatedAssessmentRetrieveList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssessmentRetrieve[];
};
export type PaginatedAssessmentRetrieveListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssessmentRetrieveRead[];
};
export type PaginatedAssessmentRetrieveListWrite = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: AssessmentRetrieveWrite[];
};
export type AssessmentCreate = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  completed_at?: string | null;
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
  protocol_set_id?: number;
};
export type AssessmentCreateRead = {
  id: string;
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  reviewers: UserRead[];
  applied_themes?: any;
  completed: boolean;
  completed_at?: string | null;
  steps: StepsField[];
  verifiers: UserRead[];
  siteassessment_set: SiteAssessmentSetRead[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  is_favorite: boolean;
  assigned_cc: string;
  protocol_set_id?: number;
};
export type AssessmentCreateWrite = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  standards_per_site: AssessmentSiteWithStandards[];
  completed_at?: string | null;
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
  protocol_set_id?: number;
};
export type StepsFieldCreate = {
  role: string;
  due_date: string;
};
export type StepsFieldUpdate = {
  step_id: number;
  due_date: string;
};
export type Steps = StepsFieldCreate | StepsFieldUpdate;
export type AssessmentCreateRequest = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  completed_at?: string | null;
  steps: Steps[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
  protocol_set_id?: number;
};
export type AssessmentCreateRequestRead = {
  id: string;
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  reviewers: UserRead[];
  applied_themes?: any;
  completed: boolean;
  completed_at?: string | null;
  steps: Steps[];
  verifiers: UserRead[];
  siteassessment_set: SiteAssessmentSetRead[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  is_favorite: boolean;
  assigned_cc: string;
  protocol_set_id?: number;
};
export type AssessmentCreateRequestWrite = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  standards_per_site: AssessmentSiteWithStandards[];
  completed_at?: string | null;
  steps: Steps[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
  protocol_set_id?: number;
};
export type AssessmentUpdate = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  completed_at?: string | null;
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
};
export type AssessmentUpdateRead = {
  id: string;
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  reviewers: UserRead[];
  applied_themes?: any;
  completed: boolean;
  completed_at?: string | null;
  steps: StepsField[];
  verifiers: UserRead[];
  siteassessment_set: SiteAssessmentSetRead[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  is_favorite: boolean;
  assigned_cc: string;
};
export type AssessmentUpdateWrite = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  standards_per_site: AssessmentSiteWithStandards[];
  completed_at?: string | null;
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
};
export type ValidationErrorEnum = "validation_error";
export type AttrD81Enum = "non_field_errors";
export type Code023Enum = "invalid" | "null";
export type ApiV1AssessmentsAssessmentsUpdateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code023Enum;
  detail: string;
};
export type Attr5EbEnum = "name";
export type CodeE4EEnum = "invalid" | "null_characters_not_allowed" | "surrogate_characters_not_allowed";
export type ApiV1AssessmentsAssessmentsUpdateNameErrorComponent = {
  attr: Attr5EbEnum;
  code: CodeE4EEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateAppliedSitesErrorComponentAttrEnum = "applied_sites";
export type Code633Enum = "does_not_exist" | "incorrect_type" | "not_a_list" | "null" | "required";
export type ApiV1AssessmentsAssessmentsUpdateAppliedSitesErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateAppliedSitesErrorComponentAttrEnum;
  code: Code633Enum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateFinalSubmissionDateErrorComponentAttrEnum = "final_submission_date";
export type CodeCeaEnum = "datetime" | "invalid";
export type ApiV1AssessmentsAssessmentsUpdateFinalSubmissionDateErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateFinalSubmissionDateErrorComponentAttrEnum;
  code: CodeCeaEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateAppliedThemesErrorComponentAttrEnum = "applied_themes";
export type ApiV1AssessmentsAssessmentsUpdateAppliedThemesErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateAppliedThemesErrorComponentAttrEnum;
  code: Code023Enum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteNonFieldErrorsErrorComponentAttrEnum =
  "standards_per_site.non_field_errors";
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteNonFieldErrorsErrorComponentCodeEnum =
  | "not_a_list"
  | "null"
  | "required";
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteNonFieldErrorsErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteNonFieldErrorsErrorComponentAttrEnum;
  code: ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteNonFieldErrorsErrorComponentCodeEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexNonFieldErrorsErrorComponentAttrEnum =
  "standards_per_site.INDEX.non_field_errors";
export type CodeF7EEnum = "invalid" | "null" | "required";
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexNonFieldErrorsErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexNonFieldErrorsErrorComponentAttrEnum;
  code: CodeF7EEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexSiteIdErrorComponentAttrEnum =
  "standards_per_site.INDEX.site_id";
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexSiteIdErrorComponentCodeEnum =
  | "does_not_exist"
  | "incorrect_type"
  | "null";
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexSiteIdErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexSiteIdErrorComponentAttrEnum;
  code: ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexSiteIdErrorComponentCodeEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexStandardsErrorComponentAttrEnum =
  "standards_per_site.INDEX.standards";
export type Code2DeEnum = "does_not_exist" | "incorrect_type" | "not_a_list" | "null";
export type ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexStandardsErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexStandardsErrorComponentAttrEnum;
  code: Code2DeEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateCompletedAtErrorComponentAttrEnum = "completed_at";
export type Code5A0Enum = "date" | "invalid" | "make_aware" | "overflow";
export type ApiV1AssessmentsAssessmentsUpdateCompletedAtErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateCompletedAtErrorComponentAttrEnum;
  code: Code5A0Enum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateStepsErrorComponentAttrEnum = "steps";
export type ApiV1AssessmentsAssessmentsUpdateStepsErrorComponentCodeEnum = "null" | "required";
export type ApiV1AssessmentsAssessmentsUpdateStepsErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateStepsErrorComponentAttrEnum;
  code: ApiV1AssessmentsAssessmentsUpdateStepsErrorComponentCodeEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateFirstVerificationAssignmentErrorComponentAttrEnum =
  "first_verification_assignment";
export type ApiV1AssessmentsAssessmentsUpdateFirstVerificationAssignmentErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateFirstVerificationAssignmentErrorComponentAttrEnum;
  code: Code5A0Enum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateSourceAssessmentIdErrorComponentAttrEnum = "source_assessment_id";
export type ApiV1AssessmentsAssessmentsUpdateSourceAssessmentIdErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateSourceAssessmentIdErrorComponentAttrEnum;
  code: Code023Enum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateAssignedCcErrorComponentAttrEnum = "assigned_cc";
export type Code6C0Enum = "does_not_exist" | "incorrect_type" | "null" | "required";
export type ApiV1AssessmentsAssessmentsUpdateAssignedCcErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsUpdateAssignedCcErrorComponentAttrEnum;
  code: Code6C0Enum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsUpdateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1AssessmentsAssessmentsUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: "name";
    } & ApiV1AssessmentsAssessmentsUpdateNameErrorComponent)
  | ({
      attr: "applied_sites";
    } & ApiV1AssessmentsAssessmentsUpdateAppliedSitesErrorComponent)
  | ({
      attr: "final_submission_date";
    } & ApiV1AssessmentsAssessmentsUpdateFinalSubmissionDateErrorComponent)
  | ({
      attr: "applied_themes";
    } & ApiV1AssessmentsAssessmentsUpdateAppliedThemesErrorComponent)
  | ({
      attr: "standards_per_site.non_field_errors";
    } & ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteNonFieldErrorsErrorComponent)
  | ({
      attr: "standards_per_site.INDEX.non_field_errors";
    } & ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexNonFieldErrorsErrorComponent)
  | ({
      attr: "standards_per_site.INDEX.site_id";
    } & ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexSiteIdErrorComponent)
  | ({
      attr: "standards_per_site.INDEX.standards";
    } & ApiV1AssessmentsAssessmentsUpdateStandardsPerSiteIndexStandardsErrorComponent)
  | ({
      attr: "completed_at";
    } & ApiV1AssessmentsAssessmentsUpdateCompletedAtErrorComponent)
  | ({
      attr: "steps";
    } & ApiV1AssessmentsAssessmentsUpdateStepsErrorComponent)
  | ({
      attr: "first_verification_assignment";
    } & ApiV1AssessmentsAssessmentsUpdateFirstVerificationAssignmentErrorComponent)
  | ({
      attr: "source_assessment_id";
    } & ApiV1AssessmentsAssessmentsUpdateSourceAssessmentIdErrorComponent)
  | ({
      attr: "assigned_cc";
    } & ApiV1AssessmentsAssessmentsUpdateAssignedCcErrorComponent);
export type ApiV1AssessmentsAssessmentsUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1AssessmentsAssessmentsUpdateError[];
};
export type ClientErrorEnum = "client_error";
export type ParseErrorCodeEnum = "parse_error";
export type ParseError = {
  code: ParseErrorCodeEnum;
  detail: string;
  attr: string | null;
};
export type ParseErrorResponse = {
  type: ClientErrorEnum;
  errors: ParseError[];
};
export type ApiV1AssessmentsAssessmentsUpdateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1AssessmentsAssessmentsUpdateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type ErrorCode401Enum = "authentication_failed" | "not_authenticated";
export type Error401 = {
  code: ErrorCode401Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse401 = {
  type: ClientErrorEnum;
  errors: Error401[];
};
export type ErrorCode403Enum = "permission_denied";
export type Error403 = {
  code: ErrorCode403Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse403 = {
  type: ClientErrorEnum;
  errors: Error403[];
};
export type ErrorCode404Enum = "not_found";
export type Error404 = {
  code: ErrorCode404Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse404 = {
  type: ClientErrorEnum;
  errors: Error404[];
};
export type ErrorCode405Enum = "method_not_allowed";
export type Error405 = {
  code: ErrorCode405Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse405 = {
  type: ClientErrorEnum;
  errors: Error405[];
};
export type ErrorCode406Enum = "not_acceptable";
export type Error406 = {
  code: ErrorCode406Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse406 = {
  type: ClientErrorEnum;
  errors: Error406[];
};
export type ErrorCode415Enum = "unsupported_media_type";
export type Error415 = {
  code: ErrorCode415Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse415 = {
  type: ClientErrorEnum;
  errors: Error415[];
};
export type ServerErrorEnum = "server_error";
export type ErrorCode500Enum = "error";
export type Error500 = {
  code: ErrorCode500Enum;
  detail: string;
  attr: string | null;
};
export type ErrorResponse500 = {
  type: ServerErrorEnum;
  errors: Error500[];
};
export type AssessmentRequest = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  completed_at?: string | null;
  steps: Steps[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
};
export type AssessmentRequestRead = {
  id: string;
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  reviewers: UserRead[];
  applied_themes?: any;
  completed: boolean;
  completed_at?: string | null;
  steps: Steps[];
  verifiers: UserRead[];
  siteassessment_set: SiteAssessmentSetRead[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  is_favorite: boolean;
  assigned_cc: string;
};
export type AssessmentRequestWrite = {
  name?: string | null;
  applied_sites: string[];
  final_submission_date?: string | null;
  applied_themes?: any;
  standards_per_site: AssessmentSiteWithStandards[];
  completed_at?: string | null;
  steps: Steps[];
  first_verification_assignment?: string | null;
  source_assessment_id?: string;
  assigned_cc: string;
};
export type AssessmentPartialUpdate = {
  assigned_cc: string;
};
export type PatchedAssessmentPartialUpdate = {
  assigned_cc?: string;
};
export type SiteAssessmentWithRecentComments = {};
export type RecentComment = {
  content: string;
  tagged_users?: string[];
};
export type RecentCommentRead = {
  id: string;
  content: string;
  author: UserRead;
  commented_at: string;
  is_deleted: boolean;
  tagged_users?: string[];
  hyperlink: string;
  question_name: string;
};
export type SiteAssessmentWithRecentCommentsRead = {
  site_assessment_id: string;
  site_name: string;
  comments: RecentCommentRead[];
};
export type ApiV1AssessmentsAssessmentsCompleteCreateErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type ApiV1AssessmentsAssessmentsFavoriteCreateErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type ApiV1AssessmentsAssessmentsFavoriteDestroyErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type AvailableProtocolQuestion = {
  name: string;
};
export type AvailableProtocolQuestionRead = {
  id: number;
  name: string;
};
export type AvailableProtocolQuestionsSubTheme = {
  sub_theme_id: string;
  sub_theme_name: string;
  questions: AvailableProtocolQuestion[];
};
export type AvailableProtocolQuestionsSubThemeRead = {
  sub_theme_id: string;
  sub_theme_name: string;
  questions: AvailableProtocolQuestionRead[];
};
export type AvailableProtocolQuestionsTheme = {
  theme_id: string;
  theme_name: string;
  sub_themes: AvailableProtocolQuestionsSubTheme[];
};
export type AvailableProtocolQuestionsThemeRead = {
  theme_id: string;
  theme_name: string;
  sub_themes: AvailableProtocolQuestionsSubThemeRead[];
};
export type SelfAssessmentRatingEnum = 99 | 2 | 3 | 4 | 5;
export type NullEnum = null;
export type EvidenceFile = {
  url?: string | null;
  key?: string | null;
  file_name?: string | null;
};
export type EvidenceFileRead = {
  id: string;
  url?: string | null;
  key?: string | null;
  file_name?: string | null;
};
export type Evidence = {
  id?: string;
  description?: string | null;
  file: EvidenceFile;
};
export type EvidenceRead = {
  id?: string;
  description?: string | null;
  file: EvidenceFileRead;
};
export type TaskInProtocol = {
  site_name: string;
  site_id: string;
  site_assessment_id: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  evidences: Evidence[];
};
export type TaskInProtocolRead = {
  id: string;
  site_name: string;
  site_id: string;
  site_assessment_id: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  evidences: EvidenceRead[];
};
export type Theme = {
  /** Is covered with model translations. */
  name: string;
  short_name?: string | null;
};
export type ThemeRead = {
  id: number;
  /** Is covered with model translations. */
  name: string;
  short_name?: string | null;
};
export type RevieweAssignmentSteps = {
  step_index: number;
  date: string;
};
export type ThemeName = {
  name: string;
};
export type RevieweAssignmentGroupsUser = {
  last_name: string;
  first_name: string;
  id: string;
};
export type RevieweAssignmentGroups = {
  step_start: number;
  step_end: number;
  users: RevieweAssignmentGroupsUser[];
};
export type RevieweAssignmentRowsItem = {
  theme: ThemeName[];
  row_height: number;
  groups: RevieweAssignmentGroups[];
};
export type RevieweAssignment = {
  unassigned_themes: Theme[];
  steps: RevieweAssignmentSteps[];
  rows: RevieweAssignmentRowsItem[];
};
export type RevieweAssignmentRead = {
  unassigned_themes: ThemeRead[];
  steps: RevieweAssignmentSteps[];
  rows: RevieweAssignmentRowsItem[];
};
export type ReviewersGroup = {
  id: number;
  name: string;
  created_manually: boolean;
  reviewers: User[];
};
export type ReviewersGroupRead = {
  id: number;
  name: string;
  created_manually: boolean;
  reviewers: UserRead[];
};
export type Reviewers = {
  reviewers: User[];
  reviewers_groups: ReviewersGroup[];
};
export type ReviewersRead = {
  reviewers: UserRead[];
  reviewers_groups: ReviewersGroupRead[];
};
export type ReviewAssignmentCreateUpdate = {
  steps_id: number[];
  themes_group_id?: number;
  themes?: number[];
  reviewers_group_id?: number;
  reviewers_group_name?: string;
  reviewers?: string[];
};
export type ReviewAssignedThemes = {
  due_date: string;
  themes_group_id: number;
  themes: Theme[];
  reviewers_group_id: number;
  reviewers: User[];
};
export type ReviewAssignedThemesRead = {
  id: number;
  due_date: string;
  themes_group_id: number;
  themes: ThemeRead[];
  reviewers_group_id: number;
  reviewers: UserRead[];
  /** The `similar_assignments_in_other_steps` is annotated in `ReviewAssignmentManager` manager. */
  similar_assignments_in_other_steps: number[];
};
export type StepsFieldForAssigning = {
  id: number;
  due_date: string;
  name: string;
};
export type ReviewUnassignedThemesGroups = {
  group_id: number;
  themes: Theme[];
};
export type ReviewUnassignedThemesGroupsRead = {
  group_id: number;
  themes: ThemeRead[];
};
export type UnassignedTheme = ReviewUnassignedThemesGroups | Theme;
export type UnassignedThemeRead = ReviewUnassignedThemesGroupsRead | ThemeRead;
export type SiteAssessment = {
  site: string;
  assessment: string;
  applied_standards: number[];
  applied_themes: number[];
};
export type SiteAssessmentRead = {
  id: string;
  site: string;
  assessment: string;
  applied_standards: number[];
  applied_themes: number[];
};
export type SiteAssessmentSignOffAttachment = {
  id: string;
  s3_key: string;
  file_name: string;
  description?: string | null;
};
export type SiteAssessmentApprovalRetrieve = {
  approved_by: User;
  approved_at: string;
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  attachments: SiteAssessmentSignOffAttachment[];
};
export type SiteAssessmentApprovalRetrieveRead = {
  approved_by: UserRead;
  approved_at: string;
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  attachments: SiteAssessmentSignOffAttachment[];
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalRetrieveErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type SiteAssessmentApprovalCreated = {
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  approved_at?: string;
  approved_by?: string | null;
  /** When the record was created */
  created_at?: string;
};
export type SiteAssessmentApprovalCreatedRead = {
  id: number;
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  approved_at?: string;
  approved_by?: string | null;
  /** When the record was created */
  created_at?: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code023Enum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateGeneralManagerErrorComponentAttrEnum =
  "general_manager";
export type Code3AbEnum =
  | "blank"
  | "invalid"
  | "null"
  | "null_characters_not_allowed"
  | "surrogate_characters_not_allowed";
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateGeneralManagerErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateGeneralManagerErrorComponentAttrEnum;
  code: Code3AbEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateCommentsErrorComponentAttrEnum = "comments";
export type CodeA3CEnum =
  | "blank"
  | "invalid"
  | "null"
  | "null_characters_not_allowed"
  | "required"
  | "surrogate_characters_not_allowed";
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateCommentsErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateCommentsErrorComponentAttrEnum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileErrorComponentAttrEnum = "file";
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileErrorComponentCodeEnum = "not_a_list" | "null";
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileErrorComponentAttrEnum;
  code: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileErrorComponentCodeEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileIndexErrorComponentAttrEnum = "file.INDEX";
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileIndexErrorComponentCodeEnum =
  | "empty"
  | "invalid"
  | "invalid_mime_type"
  | "max_content_size"
  | "no_name"
  | "null"
  | "read_error"
  | "required";
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileIndexErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileIndexErrorComponentAttrEnum;
  code: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileIndexErrorComponentCodeEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateDescriptionsErrorComponentAttrEnum = "descriptions";
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateDescriptionsErrorComponent = {
  attr: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateDescriptionsErrorComponentAttrEnum;
  code: Code3AbEnum;
  detail: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateNonFieldErrorsErrorComponent)
  | ({
      attr: "general_manager";
    } & ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateGeneralManagerErrorComponent)
  | ({
      attr: "comments";
    } & ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateCommentsErrorComponent)
  | ({
      attr: "file";
    } & ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileErrorComponent)
  | ({
      attr: "file.INDEX";
    } & ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateFileIndexErrorComponent)
  | ({
      attr: "descriptions";
    } & ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateDescriptionsErrorComponent);
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateError[];
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type SiteAssessmentApprovalCreate = {
  general_manager?: string;
  comments: string;
  file?: string[];
  /** A JSON-encoded list of strings, one for each file. */
  descriptions?: string;
};
export type AssignThemes = {
  assignment: {
    [key: string]: (string | null)[];
  };
};
export type AssignedThemes = {
  assigned_themes?: any;
};
export type AssignedThemesRead = {
  assigned_themes?: any;
  unassigned_themes: number[];
};
export type TaskWithRecentComments = {};
export type Comment = {
  content: string;
  tagged_users?: string[];
};
export type CommentRead = {
  id: string;
  content: string;
  author: UserRead;
  commented_at: string;
  is_deleted: boolean;
  tagged_users?: string[];
};
export type TaskWithRecentCommentsRead = {
  task_id: string;
  question_name: string;
  comments: CommentRead[];
  another_comments: number;
  hyperlink: string;
};
export type SiteAssessmentVerificationRetrieve = {
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  verified_at: string;
  verified_by: User;
  /** When the record was created */
  created_at?: string;
  attachments: SiteAssessmentSignOffAttachment[];
};
export type SiteAssessmentVerificationRetrieveRead = {
  id: number;
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  verified_at: string;
  verified_by: UserRead;
  /** When the record was created */
  created_at?: string;
  attachments: SiteAssessmentSignOffAttachment[];
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationRetrieveErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type SiteAssessmentVerificationCreated = {
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  verified_at: string;
  verified_by: User;
  /** When the record was created */
  created_at?: string;
};
export type SiteAssessmentVerificationCreatedRead = {
  id: number;
  /** Approval made in name of */
  general_manager?: string | null;
  comments?: string;
  verified_at: string;
  verified_by: UserRead;
  /** When the record was created */
  created_at?: string;
};
export type ApiV1AssessmentsAssessmentsSiteAssessmentsVerificationCreateErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type SiteAssessmentVerificationCreate = {
  general_manager?: string;
  comments: string;
  file?: string[];
  /** A JSON-encoded list of strings, one for each file. */
  descriptions?: string;
  verified_at: string;
};
export type CreateProtocol = {
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: number;
  sub_theme: number;
  scope_of_applicability: number[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
};
export type CreateProtocolRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: number;
  sub_theme: number;
  scope_of_applicability: number[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
};
export type CreateProtocolWrite = {
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: number;
  sub_theme: number;
  scope_of_applicability: number[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  requirements?: number[];
};
export type Status59CEnum = 1 | 2 | 3 | 4 | 5;
export type Task = {
  site_assessment: string;
  referred_question: CreateProtocol;
  reviewers: number[];
  data_providers: string[];
  status?: Status59CEnum;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  stakeholder_engagement?: boolean | null;
  internal_audit?: boolean | null;
  is_deleted?: boolean;
};
export type TaskRead = {
  id: string;
  site_assessment: string;
  referred_question: CreateProtocolRead;
  reviewers: number[];
  data_providers: string[];
  status?: Status59CEnum;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  stakeholder_engagement?: boolean | null;
  internal_audit?: boolean | null;
  is_deleted?: boolean;
};
export type TaskWrite = {
  site_assessment: string;
  referred_question: CreateProtocolWrite;
  reviewers: number[];
  data_providers: string[];
  status?: Status59CEnum;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  stakeholder_engagement?: boolean | null;
  internal_audit?: boolean | null;
  is_deleted?: boolean;
};
export type ScopeOfApplicability = {
  value: string;
};
export type ScopeOfApplicabilityRead = {
  id: number;
  value: string;
};
export type GuidanceType = "note" | "verification" | "evidence";
export type StandardGuidanceNested = {
  /** Is covered with model translations. */
  content: string;
  type: GuidanceType;
};
export type StandardGuidanceNestedRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  type: GuidanceType;
};
export type HighlightedText = {
  text: string;
  highlighted: boolean;
};
export type RequirementHighlightsSection = {
  content: HighlightedText[];
};
export type HighlightedRequirement = {
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: Standard;
  standards_guidance: StandardGuidanceNested[];
  critical: boolean;
  highlights: RequirementHighlightsSection | null;
};
export type HighlightedRequirementRead = {
  id: number;
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: StandardRead;
  /** Using `first` didn't allow for prefetching for some reason. While `all` and selecting first element
    works nicely. We expect to have only one row for requirement, so it should be safe. */
  section: string;
  sub_section: string;
  standards_guidance: StandardGuidanceNestedRead[];
  section_ref: string;
  sub_section_ref: string;
  critical: boolean;
  highlights: RequirementHighlightsSection | null;
};
export type CorporateGuidance = {
  /** Is covered with model translations. */
  content: string;
};
export type CorporateGuidanceRead = {
  id: string;
  /** Is covered with model translations. */
  content: string;
};
export type ProtocolHighlights = {
  content: HighlightedText[];
};
export type GetProtocol = {
  name: string;
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: Theme;
  sub_theme: Theme;
  scope_of_applicability: ScopeOfApplicability[];
  requirements: HighlightedRequirement[];
  corporate_guidance: CorporateGuidance[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  highlights: ProtocolHighlights | null;
};
export type GetProtocolRead = {
  id: number;
  name: string;
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: ThemeRead;
  sub_theme: ThemeRead;
  scope_of_applicability: ScopeOfApplicabilityRead[];
  requirements: HighlightedRequirementRead[];
  corporate_guidance: CorporateGuidanceRead[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  highlights: ProtocolHighlights | null;
};
export type GetTask = {
  site_assessment: string;
  referred_question: GetProtocol;
  data_providers: string[];
  status?: Status59CEnum;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  stakeholder_engagement?: boolean | null;
  internal_audit?: boolean | null;
  evidences: Evidence[];
  is_deleted?: boolean;
};
export type GetTaskRead = {
  id: string;
  site_assessment: string;
  referred_question: GetProtocolRead;
  reviewers: string[];
  data_providers: string[];
  status?: Status59CEnum;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  stakeholder_engagement?: boolean | null;
  internal_audit?: boolean | null;
  evidences: EvidenceRead[];
  is_deleted?: boolean;
  updated_at: string;
};
export type CommentWithLink = {
  content: string;
  tagged_users?: string[];
  hyperlink?: string | null;
};
export type CommentWithLinkRead = {
  id: string;
  content: string;
  author: UserRead;
  commented_at: string;
  is_deleted: boolean;
  tagged_users?: string[];
  hyperlink?: string | null;
};
export type NestedTaskRelatedUser = {
  first_name?: string;
  last_name?: string;
  email: string;
};
export type NestedTaskRelatedUserRead = {
  id: string;
  first_name?: string;
  last_name?: string;
  email: string;
  is_inactive: boolean;
};
export type TaskRelatedUser = {
  edited_by: NestedTaskRelatedUser[];
  reviewed_by: NestedTaskRelatedUser[];
  last_edited?: string | null;
};
export type TaskRelatedUserRead = {
  edited_by: NestedTaskRelatedUserRead[];
  reviewed_by: NestedTaskRelatedUserRead[];
  last_edited?: string | null;
};
export type TaskFromOtherSites = {
  assessment_name: string;
  assessment_id: string;
  site_name: string;
  site_id: string;
  site_assessment_id: string;
  status: number;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  evidences: Evidence[];
  is_deleted?: boolean;
};
export type TaskFromOtherSitesRead = {
  id: string;
  assessment_name: string;
  assessment_id: string;
  site_name: string;
  site_id: string;
  site_assessment_id: string;
  last_updated: string;
  status: number;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  evidences: EvidenceRead[];
  is_deleted?: boolean;
};
export type StandardBasic = {
  name: string;
};
export type StandardBasicRead = {
  id: number;
  name: string;
};
export type TaskReferredQuestionRequirements = {
  standard: StandardBasic;
};
export type TaskReferredQuestionRequirementsRead = {
  standard: StandardBasicRead;
};
export type TaskReferredQuestion = {
  /** Is covered with model translations. */
  content: string;
  name: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  theme: number;
  sub_theme: number;
  scope_of_applicability: number[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  requirements: TaskReferredQuestionRequirements[];
};
export type TaskReferredQuestionRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  name: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  theme: number;
  sub_theme: number;
  scope_of_applicability: number[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  requirements: TaskReferredQuestionRequirementsRead[];
};
export type TaskFromRelatedProtocol = {
  assessment_name: string;
  assessment_id: string;
  site_name: string;
  site_id: string;
  site_assessment_id: string;
  status: number;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  evidences: Evidence[];
  is_deleted?: boolean;
  referred_question: TaskReferredQuestion;
};
export type TaskFromRelatedProtocolRead = {
  id: string;
  assessment_name: string;
  assessment_id: string;
  site_name: string;
  site_id: string;
  site_assessment_id: string;
  last_updated: string;
  status: number;
  conformity_assessment_response?: string;
  areas_of_improvement_response?: string;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  evidences: EvidenceRead[];
  is_deleted?: boolean;
  referred_question: TaskReferredQuestionRead;
};
export type ReviewEnum = "approved" | "declined";
export type Review = {
  review: ReviewEnum;
};
export type Answer = {
  conformity_assessment_response?: string | null;
  areas_of_improvement_response?: string | null;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  stakeholder_engagement?: boolean | null;
  internal_audit?: boolean | null;
  is_draft?: boolean;
};
export type AnswerRead = {
  id: string;
  conformity_assessment_response?: string | null;
  areas_of_improvement_response?: string | null;
  self_assessment_rating?: (SelfAssessmentRatingEnum | NullEnum) | null;
  stakeholder_engagement?: boolean | null;
  internal_audit?: boolean | null;
  is_draft?: boolean;
};
export type CustomSite = {
  name: string;
};
export type CustomSiteRead = {
  id: string;
  name: string;
  type: string;
};
export type RelatedStandard = {
  name: string;
};
export type RelatedStandardRead = {
  id: number;
  name: string;
};
export type SiteWithRelatedStandards = {
  site: CustomSite;
  standards: RelatedStandard[];
};
export type SiteWithRelatedStandardsRead = {
  site: CustomSiteRead;
  standards: RelatedStandardRead[];
};
export type VerifierStepDetail = {
  verifier_step: StepsField;
  verifiers: User[];
};
export type VerifierStepDetailRead = {
  verifier_step: StepsField;
  verifiers: UserRead[];
};
export type AssignVerifiers = {
  verifiers: string[];
};
export type PaginatedEvidenceFileList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: EvidenceFile[];
};
export type PaginatedEvidenceFileListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: EvidenceFileRead[];
};
export type AvailableTasksSingleTask = {
  id: string;
  name: string;
  status: number;
  reviewers: User[];
  data_providers: User[];
  is_deleted: boolean;
};
export type AvailableTasksSingleTaskRead = {
  id: string;
  name: string;
  status: number;
  reviewers: UserRead[];
  data_providers: UserRead[];
  is_deleted: boolean;
};
export type AvailableTasksSubTheme = {
  sub_theme_id: string;
  sub_theme_name: string;
  tasks: AvailableTasksSingleTask[];
};
export type AvailableTasksSubThemeRead = {
  sub_theme_id: string;
  sub_theme_name: string;
  tasks: AvailableTasksSingleTaskRead[];
};
export type AvailableTasksTheme = {
  theme_id: string;
  theme_name: string;
  sub_themes: AvailableTasksSubTheme[];
};
export type AvailableTasksThemeRead = {
  theme_id: string;
  theme_name: string;
  sub_themes: AvailableTasksSubThemeRead[];
};
export type AvailableTasksSingleTaskWithReference = {
  id: string;
  name: string;
  status: number;
  reviewers: User[];
  data_providers: User[];
  is_deleted: boolean;
  requirement_reference: string;
};
export type AvailableTasksSingleTaskWithReferenceRead = {
  id: string;
  name: string;
  status: number;
  reviewers: UserRead[];
  data_providers: UserRead[];
  is_deleted: boolean;
  requirement_reference: string;
};
export type AvailableTasksSubSection = {
  sub_section_ref: string;
  sub_section_name: string;
  tasks: AvailableTasksSingleTaskWithReference[];
};
export type AvailableTasksSubSectionRead = {
  sub_section_ref: string;
  sub_section_name: string;
  tasks: AvailableTasksSingleTaskWithReferenceRead[];
};
export type AvailableTasksSection = {
  section_ref: string;
  section_name: string;
  sub_sections: AvailableTasksSubSection[];
};
export type AvailableTasksSectionRead = {
  section_ref: string;
  section_name: string;
  sub_sections: AvailableTasksSubSectionRead[];
};
export type StandardSimple = {
  name: string;
};
export type StandardSimpleRead = {
  id: number;
  name: string;
};
export type GetSite = {
  name: string;
  address1?: string | null;
  address2?: string | null;
  country: string;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  type: ScopeOfApplicability;
  coordinator: User;
  general_manager?: string | null;
  location?: string | null;
  default_standards: StandardSimple[];
  assessments_count: number;
};
export type GetSiteRead = {
  id: string;
  name: string;
  address1?: string | null;
  address2?: string | null;
  country: string;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  type: ScopeOfApplicabilityRead;
  coordinator: UserRead;
  general_manager?: string | null;
  location?: string | null;
  default_standards: StandardSimpleRead[];
  assessments_count: number;
};
export type PaginatedGetSiteList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: GetSite[];
};
export type PaginatedGetSiteListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: GetSiteRead[];
};
export type WriteSite = {
  name: string;
  address1?: string | null;
  address2?: string | null;
  country: string;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  type: number;
  coordinator: string | null;
  general_manager?: string | null;
  location?: string | null;
  default_standards: number[];
};
export type WriteSiteRead = {
  id: string;
  name: string;
  address1?: string | null;
  address2?: string | null;
  country: string;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  type: number;
  coordinator: string | null;
  general_manager?: string | null;
  location?: string | null;
  default_standards: number[];
};
export type Site = {
  name: string;
  address1?: string | null;
  address2?: string | null;
  country: string;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  coordinator?: string | null;
  general_manager?: string | null;
  location?: string | null;
  default_standards: number[];
};
export type SiteRead = {
  id: string;
  name: string;
  address1?: string | null;
  address2?: string | null;
  country: string;
  city?: string | null;
  state?: string | null;
  postcode?: string | null;
  type: ScopeOfApplicabilityRead;
  coordinator?: string | null;
  general_manager?: string | null;
  location?: string | null;
  default_standards: number[];
};
export type SiteWithAssignedAssessmentsWithStandardsForReports = {
  site_id: string;
  site_name: string;
};
export type StandardForReports = {
  standard_id: string;
  standard_name: string;
  has_rollup?: boolean;
  disable_aggregation?: boolean;
};
export type SiteAssessmentWithStandardsForReports = {
  site_assessment_id: string;
  assessment_id: string;
  assessment_name: string;
  standards: StandardForReports[];
};
export type SiteAssessmentWithStandardsForReportsRead = {
  site_assessment_id: string;
  assessment_id: string;
  assessment_name: string;
  assessment_status: string;
  standards: StandardForReports[];
};
export type SiteWithAssignedAssessmentsWithStandardsForReportsRead = {
  site_id: string;
  site_name: string;
  site_assessments: SiteAssessmentWithStandardsForReportsRead[];
};
export type AssessmentBasic = {
  name?: string | null;
};
export type AssessmentBasicRead = {
  id: string;
  name?: string | null;
};
export type SiteBasic = {
  name: string;
};
export type SiteBasicRead = {
  id: string;
  name: string;
};
export type SiteWithAssignedAssessmentsWithStandardsFilters = {
  assessments: AssessmentBasic[];
  standards: StandardBasic[];
  sites: SiteBasic[];
};
export type SiteWithAssignedAssessmentsWithStandardsFiltersRead = {
  assessments: AssessmentBasicRead[];
  standards: StandardBasicRead[];
  sites: SiteBasicRead[];
  assessment_status: string[][];
};
export type SiteFilters = {
  type: string[][];
  country: string[][];
  coordinator: string[][];
};
export type ImportSites = {
  file: string;
};
export type SiteAssessmentWithTaskAmounts = {
  site_assessment_id: string;
  unassigned_amount: number;
  in_draft_amount: number;
  declined_amount: number;
  in_review_amount: number;
  reviewed_amount: number;
  total_amount: number;
};
export type ModeEnum = "aup" | "acf" | "aup_and_acf";
export type AssessmentForUpdateHistory = {
  run_at: string;
  finished_at: string;
  previous_protocol_set?: number | null;
  updated_protocol_set?: number | null;
  /** Indicates the mode of the assessment update.
    
    * `aup` - Assessment update panel
    * `acf` - Assessment carry forward
    * `aup_and_acf` - Assessment update panel and carry forward */
  mode?: ModeEnum;
};
export type AssessmentForUpdateHistoryRead = {
  id: number;
  run_by: UserRead | null;
  run_at: string;
  finished_at: string;
  previous_protocol_set?: number | null;
  updated_protocol_set?: number | null;
  /** Indicates the mode of the assessment update.
    
    * `aup` - Assessment update panel
    * `acf` - Assessment carry forward
    * `aup_and_acf` - Assessment update panel and carry forward */
  mode?: ModeEnum;
};
export type AssessmentForUpdate = {
  id: string;
  name: string;
  protocol_set_version: number | null;
  active: boolean;
  history: AssessmentForUpdateHistory[];
};
export type AssessmentForUpdateRead = {
  id: string;
  name: string;
  protocol_set_version: number | null;
  active: boolean;
  history: AssessmentForUpdateHistoryRead[];
};
export type AssessmentUpdatePanel = {
  current_protocol_set_version: number;
  assessments: AssessmentForUpdate[];
};
export type AssessmentUpdatePanelRead = {
  current_protocol_set_version: number;
  assessments: AssessmentForUpdateRead[];
};
export type ProtocolSetsComparisonSide = {
  id: number;
  name: string;
  content: string;
  erm_mapping_note: string;
  internal_note: string;
  sub_theme_id: number;
  theme_id: number;
  sub_theme_name: string;
  theme_name: string;
  internal_audit: boolean;
  stakeholder_engagement: boolean;
  scopes_of_applicability: string[];
  requirements: string[];
  related_questions: string[];
  related_questions_ids: number[];
};
export type AssessmentUpdatePanelComparisonListToMigrate = {
  protocol_question_old: ProtocolSetsComparisonSide;
  protocol_question_new: ProtocolSetsComparisonSide;
  is_renamed: boolean;
  has_data: boolean;
  is_not_in_soa: boolean;
  is_requirement_valid: boolean;
};
export type AssessmentUpdatePanelComparisonListToMigrateRead = {
  site_name: string;
  columns_changed: string[];
  protocol_question_old: ProtocolSetsComparisonSide;
  protocol_question_new: ProtocolSetsComparisonSide;
  is_renamed: boolean;
  has_data: boolean;
  is_not_in_soa: boolean;
  is_requirement_valid: boolean;
};
export type AssessmentUpdatePanelComparisonListToCreate = {
  protocol_question_new: ProtocolSetsComparisonSide;
};
export type AssessmentUpdatePanelComparisonListToCreateRead = {
  site_name: string;
  protocol_question_new: ProtocolSetsComparisonSide;
};
export type AssessmentUpdatePanelComparisonListToDelete = {
  protocol_question_old: ProtocolSetsComparisonSide;
  has_data: boolean;
  is_not_in_soa: boolean;
  is_requirement_valid: boolean;
};
export type AssessmentUpdatePanelComparisonListToDeleteRead = {
  site_name: string;
  protocol_question_old: ProtocolSetsComparisonSide;
  has_data: boolean;
  is_not_in_soa: boolean;
  is_requirement_valid: boolean;
};
export type AssessmentUpdatePanelComparison = {
  to_migrate: AssessmentUpdatePanelComparisonListToMigrate[];
  to_create: AssessmentUpdatePanelComparisonListToCreate[];
  to_delete: AssessmentUpdatePanelComparisonListToDelete[];
};
export type AssessmentUpdatePanelComparisonRead = {
  to_migrate: AssessmentUpdatePanelComparisonListToMigrateRead[];
  to_create: AssessmentUpdatePanelComparisonListToCreateRead[];
  to_delete: AssessmentUpdatePanelComparisonListToDeleteRead[];
};
export type SitesBi = {
  name: string;
  scope_of_applicability: string;
};
export type SitesBiRead = {
  id: string;
  name: string;
  /** Concatenates address fields into a single string. Ignore None or empty fields. */
  address: string;
  associated_standards: number[];
  scope_of_applicability: string;
};
export type AssessmentBi = {
  name?: string | null;
  year: string;
};
export type AssessmentBiRead = {
  id: string;
  name?: string | null;
  state: string;
  year: string;
};
export type SiteAssessmentBi = {};
export type SiteAssessmentBiRead = {
  id: string;
  site_id: string;
  assessment_id: string;
};
export type SiteAssessmentAppliedStandardsBi = {
  site_assessment_id: string;
  standard_id: number;
};
export type StandardsBi = {
  name: string;
  full_name: string;
  body?: string | null;
};
export type StandardsBiRead = {
  id: number;
  name: string;
  full_name: string;
  body?: string | null;
};
export type RequirementBi = {
  section_title: string;
  sub_section_title: string;
  reference: string;
};
export type RequirementBiRead = {
  id: number;
  standard_id: number;
  section_ref: string;
  section_title: string;
  sub_section_ref: string;
  sub_section_title: string;
  reference: string;
};
export type TaskBi = {
  conformity_level: string;
  status: string;
};
export type TaskBiRead = {
  id: string;
  site_assessment_id: string;
  protocol_question_id: string;
  /** Is covered with model translations. */
  theme: string;
  /** Is covered with model translations. */
  sub_theme: string;
  conformity_level: string;
  status: string;
};
export type TaskAssociatedRequirements = {
  task_id: string;
  requirement_id: number;
};
export type TaskByStandardBi = {
  task_id: string;
  requirement_id: number;
  conformity_level: string;
};
export type TmsRollupBi = {
  site_assessment_id: string;
  standard_id: number;
  section_ref: string;
  section_title: string;
  conformity_level: string;
};
export type BiExport = {
  sites: SitesBi[];
  assessments: AssessmentBi[];
  site_assessments: SiteAssessmentBi[];
  site_assessments__applied_standards: SiteAssessmentAppliedStandardsBi[];
  standards: StandardsBi[];
  requirements: RequirementBi[];
  tasks: TaskBi[];
  task_selected_associated_requirements: TaskAssociatedRequirements[];
  task_all_associated_requirements: TaskAssociatedRequirements[];
  report__tasks_by_standard: TaskByStandardBi[];
  report__tasks_by_tsm_requirement_rollup: TmsRollupBi[];
};
export type BiExportRead = {
  sites: SitesBiRead[];
  assessments: AssessmentBiRead[];
  site_assessments: SiteAssessmentBiRead[];
  site_assessments__applied_standards: SiteAssessmentAppliedStandardsBi[];
  standards: StandardsBiRead[];
  requirements: RequirementBiRead[];
  tasks: TaskBiRead[];
  task_selected_associated_requirements: TaskAssociatedRequirements[];
  task_all_associated_requirements: TaskAssociatedRequirements[];
  report__tasks_by_standard: TaskByStandardBi[];
  report__tasks_by_tsm_requirement_rollup: TmsRollupBi[];
};
export type ConformityHeatmapDataPoint = {};
export type ConformityHeatmapDataPointRead = {
  site_id: string;
  site_name: string;
  theme_id: number;
  theme_name: string;
  theme_short_name: string;
  conformity_score: number | null;
};
export type ConformityHeatmapFilters = {};
export type ThemeBasic = {
  /** Is covered with model translations. */
  name: string;
};
export type ThemeBasicRead = {
  id: number;
  /** Is covered with model translations. */
  name: string;
};
export type ConformityHeatmapFiltersRead = {
  years: number[];
  assessments: AssessmentBasicRead[];
  sites: SiteBasicRead[];
  standards: StandardBasicRead[];
  themes: ThemeBasicRead[];
  /** Total number of data points with current filters */
  total_count: number;
};
export type NestedUser = {
  first_name?: string;
  last_name?: string;
  email: string;
};
export type NestedUserRead = {
  id: string;
  first_name?: string;
  last_name?: string;
  email: string;
};
export type Corporation = {
  id?: string;
  name: string;
  organisation_admins: NestedUser[];
};
export type CorporationRead = {
  id?: string;
  name: string;
  created_at: string;
  organisation_admins: NestedUserRead[];
  /** Checks status of the corporation.
    If any of the organisation admins has logged in into the system it will be marked as Active.
    
    All() uses prefetch_related, which has applied filtering on user groups. See CorporationViewSet.get_queryset()
    Needs to be changed if this serializer is used in other places where there is no such filtering. */
  status: string;
};
export type Flag = {
  flag_name: string;
  enabled: boolean;
};
export type CorporationFlags = {
  flags: Flag[];
};
export type CorporationSimple = {
  id: string;
  name: string;
};
export type ApiV1DownloadSiteAssessmentsAttachmentsRetrieveErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type EventTypeEnum = "Generic" | "Product" | "Application";
export type SubTypeEnum = "Warning" | "Information";
export type ReasonEnum = "Comment";
export type BlankEnum = "";
export type Notification = {
  message: string;
  expires_at?: string | null;
  event_type: EventTypeEnum;
  sub_type: SubTypeEnum;
  sender_user: User;
  /** Targets to specific place in app, comes from FE. */
  hyperlink?: string | null;
  /** Location parameters (assessment_id, task_id, etc. To be used in future */
  location?: any;
  reason?: (ReasonEnum | BlankEnum | NullEnum) | null;
};
export type NotificationRead = {
  message: string;
  expires_at?: string | null;
  event_type: EventTypeEnum;
  sub_type: SubTypeEnum;
  created_at: string;
  sender_user: UserRead;
  /** Targets to specific place in app, comes from FE. */
  hyperlink?: string | null;
  /** Location parameters (assessment_id, task_id, etc. To be used in future */
  location?: any;
  reason?: (ReasonEnum | BlankEnum | NullEnum) | null;
};
export type NotificationRegistry = {
  read_at?: string | null;
  dismissed_at?: string | null;
  notification_body: Notification;
  receiver_user: string;
};
export type NotificationRegistryRead = {
  id: number;
  read_at?: string | null;
  dismissed_at?: string | null;
  notification_body: NotificationRead;
  receiver_user: string;
};
export type ProductNotification = {
  message: string;
  expires_at?: string | null;
  sub_type: SubTypeEnum;
};
export type ProductNotificationRead = {
  message: string;
  expires_at?: string | null;
  event_type: EventTypeEnum;
  sub_type: SubTypeEnum;
};
export type Success = {
  message: string;
};
export type ThemeAssignedLocation = {
  site_name: string;
  site_assessment_id: string;
  assessment_id: string;
  assessment_name: string;
};
export type ThemeAssignedNotification = {
  message: string;
  location: ThemeAssignedLocation;
  hyperlink: string;
  sender_user: string;
  addressee_user: string;
};
export type ProtocolSet = {
  name: string;
  version: number;
  is_draft?: boolean;
  set_to_review_at?: string | null;
  published_at?: string | null;
};
export type ProtocolSetRead = {
  id: number;
  name: string;
  version: number;
  is_draft?: boolean;
  set_to_review_by: UserRead | null;
  set_to_review_at?: string | null;
  published_by: UserRead | null;
  published_at?: string | null;
  created_by: UserRead | null;
  created_at: string;
};
export type SubTheme = {
  /** Is covered with model translations. */
  name: string;
  code?: string | null;
};
export type SubThemeRead = {
  id: number;
  /** Is covered with model translations. */
  name: string;
  code?: string | null;
};
export type ProtocolSetFilters = {
  themes: Theme[];
  sub_themes: SubTheme[];
  standards: Standard[];
  scope_of_applicabilities: ScopeOfApplicability[];
};
export type ProtocolSetFiltersRead = {
  themes: ThemeRead[];
  sub_themes: SubThemeRead[];
  standards: StandardRead[];
  scope_of_applicabilities: ScopeOfApplicabilityRead[];
};
export type LinkManyResponseItem = {
  id: number;
  linked_to: number[];
};
export type ApiV1ProtocolSetsInterlinkCreateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code023Enum;
  detail: string;
};
export type AttrBdfEnum = "protocol_questions";
export type ApiV1ProtocolSetsInterlinkCreateProtocolQuestionsErrorComponent = {
  attr: AttrBdfEnum;
  code: Code633Enum;
  detail: string;
};
export type ApiV1ProtocolSetsInterlinkCreateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1ProtocolSetsInterlinkCreateNonFieldErrorsErrorComponent)
  | ({
      attr: "protocol_questions";
    } & ApiV1ProtocolSetsInterlinkCreateProtocolQuestionsErrorComponent);
export type ApiV1ProtocolSetsInterlinkCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1ProtocolSetsInterlinkCreateError[];
};
export type ApiV1ProtocolSetsInterlinkCreateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1ProtocolSetsInterlinkCreateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type LinkProtocolQuestions = {
  protocol_questions: number[];
};
export type SimpleProtocol = {
  /** Is covered with model translations. */
  content: string;
  name: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  theme: number;
  sub_theme: number;
  scope_of_applicability: number[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
};
export type SimpleProtocolRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  name: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  theme: number;
  sub_theme: number;
  scope_of_applicability: number[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
};
export type PaginatedGetProtocolList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: GetProtocol[];
};
export type PaginatedGetProtocolListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: GetProtocolRead[];
};
export type GetProtocolSimilarityScore = {
  name: string;
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: Theme;
  sub_theme: Theme;
  scope_of_applicability: ScopeOfApplicability[];
  requirements: HighlightedRequirement[];
  corporate_guidance: CorporateGuidance[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  highlights: ProtocolHighlights | null;
};
export type GetProtocolSimilarityScoreRead = {
  id: number;
  name: string;
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: ThemeRead;
  sub_theme: ThemeRead;
  scope_of_applicability: ScopeOfApplicabilityRead[];
  requirements: HighlightedRequirementRead[];
  corporate_guidance: CorporateGuidanceRead[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  highlights: ProtocolHighlights | null;
  /** The `obj` is not exactly the `ProtocolQuestion` instance as got additional field - `similarity_score`. */
  similarity_score: number;
};
export type ProtocolSetComparisonOutputProtocolFields = {
  name: string;
  content: string;
  erm_mapping_note: string;
  internal_note: string;
  sub_theme_name: string;
  theme_name: string;
  internal_audit: boolean;
  stakeholder_engagement: boolean;
  scopes_of_applicability: string[];
  requirements: string[];
  related_questions: string[];
};
export type ProtocolSetComparisonOutput = {
  difference_type: string;
  columns_changed: string[];
  sme_names: string[];
  left: ProtocolSetComparisonOutputProtocolFields;
  right: ProtocolSetComparisonOutputProtocolFields;
};
export type ProtocolSetSerializerCreateDraft = {
  name: string;
};
export type ReportAssessment = {
  task_id: string;
  protocol_id: string;
  stakeholder_approval_required: boolean;
  internal_audit_required: boolean;
  sub_theme: string;
  theme: string;
  standard_references: string;
  question_content: string;
  conformity_level: number;
  assessment_of_conformity: string;
  areas_for_improvement: string;
  status: string;
  evidences: Evidence[];
};
export type ReportAssessmentRead = {
  task_id: string;
  protocol_id: string;
  stakeholder_approval_required: boolean;
  internal_audit_required: boolean;
  sub_theme: string;
  theme: string;
  standard_references: string;
  question_content: string;
  conformity_level: number;
  assessment_of_conformity: string;
  areas_for_improvement: string;
  status: string;
  evidences: EvidenceRead[];
};
export type PaginatedReportAssessmentList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ReportAssessment[];
};
export type PaginatedReportAssessmentListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ReportAssessmentRead[];
};
export type ReportAssessmentFilters = {
  sub_theme: string[][];
  theme: string[][];
  stakeholder_approval_required: string[][];
  internal_audit_required: string[][];
  standard_references: string[][];
  status: string[][];
  conformity_level: string[][];
};
export type Principle = {
  principle: string;
  reference: string;
  score: number;
};
export type Chapter = {
  principle_title: string;
  principle_reference: string;
  chapter: string;
  reference: string;
  score: number;
};
export type IrmaCriticalRequirements = {
  chapter_name: string;
  reference: string;
  alignment_score: number;
  does_align: boolean;
};
export type IrmaReport = {
  principles: Principle[];
  chapters: Chapter[];
  critical_requirements: IrmaCriticalRequirements[];
  irma_achievement_level: string;
};
export type ReportStandard = {
  section_ref: string;
  section: string;
  conformity_level: number;
  sub_section_ref: string;
  sub_section: string;
  reference: string;
  requirement: string;
};
export type PaginatedReportStandardList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ReportStandard[];
};
export type ReportStandardFilters = {
  section: string[][];
  sub_section: string[][];
  conformity_level: string[][];
};
export type CustomReportRead = {
  name: string;
  assessment: AssessmentBasic;
  sites: SiteBasic[];
  standards: StandardBasic[];
  creator: string;
};
export type CustomReportReadRead = {
  id: number;
  name: string;
  assessment: AssessmentBasicRead;
  sites: SiteBasicRead[];
  standards: StandardBasicRead[];
  creator: string;
};
export type CustomReportCreate = {
  name: string;
  assessment: string;
  sites: string[];
  standards: number[];
};
export type CustomReportPartialUpdate = {
  name: string;
};
export type PatchedCustomReportPartialUpdate = {
  name?: string;
};
export type ConformityLevel = {
  label: string;
  numeric_value: number;
};
export type CustomReportGeneratedDataFilters = {
  section_refs: string[];
  sub_section_refs: string[];
  references: string[];
  standard_names: string[];
  conformity_levels: ConformityLevel[];
};
export type SiteRating = {
  site_name: string;
  conformity_level: number;
};
export type CustomReportGeneratedData = {
  requirement_id: number;
  standard_id: number;
  standard_name: string;
  section_ref: string;
  section: string;
  sub_section_ref: string;
  sub_section: string;
  reference: string;
  content: string;
  conformity_levels: SiteRating[];
  aggregated_conformity_level: number;
};
export type CustomReportGeneratedDataResponse = {
  report_name: string;
  assessment_name: string;
  assessment_status: string;
  standards_names: string[];
  sites_names: string[];
  report_data: CustomReportGeneratedData[];
};
export type CustomReportListFilters = {
  assessments: AssessmentBasic[];
  standards: StandardBasic[];
  sites: SiteBasic[];
};
export type CustomReportListFiltersRead = {
  assessments: AssessmentBasicRead[];
  standards: StandardBasicRead[];
  sites: SiteBasicRead[];
  assessment_status: string[][];
};
export type GetSingleProtocol = {
  name: string;
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: Theme;
  sub_theme: Theme;
  scope_of_applicability: ScopeOfApplicability[];
  corporate_guidance: CorporateGuidance[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  highlights: ProtocolHighlights | null;
};
export type RequirementWithProtocols = {
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: Standard;
  standards_guidance: StandardGuidanceNested[];
  critical: boolean;
};
export type RequirementProtocol = {
  name: string;
  /** Is covered with model translations. */
  content: string;
};
export type RequirementId = {
  full_name: string;
};
export type RequirementIdRead = {
  id: number;
  full_name: string;
};
export type RequirementProtocolRead = {
  id: number;
  name: string;
  /** Is covered with model translations. */
  content: string;
  protocol_set_id: number | null;
  requirements: RequirementIdRead[] | null;
};
export type RequirementWithProtocolsRead = {
  id: number;
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: StandardRead;
  /** Using `first` didn't allow for prefetching for some reason. While `all` and selecting first element
    works nicely. We expect to have only one row for requirement, so it should be safe. */
  section: string;
  sub_section: string;
  standards_guidance: StandardGuidanceNestedRead[];
  section_ref: string;
  sub_section_ref: string;
  critical: boolean;
  protocols: RequirementProtocolRead[] | null;
};
export type GetSingleProtocolRead = {
  id: number;
  name: string;
  /** Is covered with model translations. */
  content: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme: ThemeRead;
  sub_theme: ThemeRead;
  scope_of_applicability: ScopeOfApplicabilityRead[];
  requirements: RequirementWithProtocolsRead[];
  corporate_guidance: CorporateGuidanceRead[];
  stakeholder_engagement: boolean;
  internal_audit: boolean;
  highlights: ProtocolHighlights | null;
};
export type PatchedCreateProtocol = {
  /** Is covered with model translations. */
  content?: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme?: number;
  sub_theme?: number;
  scope_of_applicability?: number[];
  stakeholder_engagement?: boolean;
  internal_audit?: boolean;
};
export type PatchedCreateProtocolRead = {
  id?: number;
  /** Is covered with model translations. */
  content?: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme?: number;
  sub_theme?: number;
  scope_of_applicability?: number[];
  stakeholder_engagement?: boolean;
  internal_audit?: boolean;
};
export type PatchedCreateProtocolWrite = {
  /** Is covered with model translations. */
  content?: string;
  /** Is covered with model translations. */
  erm_mapping_note?: string | null;
  /** Internal SME note for this question. */
  internal_note?: string | null;
  theme?: number;
  sub_theme?: number;
  scope_of_applicability?: number[];
  stakeholder_engagement?: boolean;
  internal_audit?: boolean;
  requirements?: number[];
};
export type ApiV1StandardsProtocolsRelatedProtocolsListErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type ApiV1StandardsProtocolsRelatedProtocolsCreateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code023Enum;
  detail: string;
};
export type ApiV1StandardsProtocolsRelatedProtocolsCreateProtocolQuestionsErrorComponent = {
  attr: AttrBdfEnum;
  code: Code633Enum;
  detail: string;
};
export type ApiV1StandardsProtocolsRelatedProtocolsCreateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1StandardsProtocolsRelatedProtocolsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: "protocol_questions";
    } & ApiV1StandardsProtocolsRelatedProtocolsCreateProtocolQuestionsErrorComponent);
export type ApiV1StandardsProtocolsRelatedProtocolsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1StandardsProtocolsRelatedProtocolsCreateError[];
};
export type ApiV1StandardsProtocolsRelatedProtocolsCreateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1StandardsProtocolsRelatedProtocolsCreateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type ApiV1StandardsProtocolsRelatedProtocolsDestroyErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type ProtocolQuestionHistory = {
  pq_version_id: number;
  event_type: string;
  changed_at: string;
  changed_by_name: string;
  changed_content: boolean;
  changed_erm_mapping_note: boolean;
  changed_internal_note: boolean;
  changed_stakeholder_engagement: boolean;
  changed_internal_audit: boolean;
  changed_theme_id: boolean;
  changed_sub_theme_id: boolean;
  changed_scope_of_applicability: boolean;
  linked_requirements: string[];
  unlinked_requirements: string[];
  linked_questions: string[];
  unlinked_questions: string[];
};
export type ProtocolQuestionReorder = {
  ids: number[];
};
export type RequirementLinkingList = {
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: Standard;
};
export type RequirementLinkingListPartialQuestion = {
  name: string;
  protocol_set?: number | null;
};
export type RequirementLinkingListPartialQuestionRead = {
  id: number;
  name: string;
  protocol_set?: number | null;
};
export type RequirementLinkingListRead = {
  id: number;
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: StandardRead;
  section_ref: string;
  sub_section_ref: string;
  /** Using `first` didn't allow for prefetching for some reason. While `all` and selecting first element
    works nicely. We expect to have only one row for requirement, so it should be safe. */
  section: string;
  sub_section: string;
  questions: RequirementLinkingListPartialQuestionRead[];
};
export type PaginatedRequirementLinkingListList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RequirementLinkingList[];
};
export type PaginatedRequirementLinkingListListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: RequirementLinkingListRead[];
};
export type RequirementWriteOutput = {
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: number;
  standards_guidance: number[];
  critical: boolean;
};
export type RequirementWriteOutputRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  section: string;
  section_ref: string;
  sub_section: string;
  sub_section_ref: string;
  standard: number;
  standards_guidance: number[];
  critical: boolean;
};
export type Code381Enum = "invalid" | "null" | "unique";
export type ApiV1StandardsRequirementsCreateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code381Enum;
  detail: string;
};
export type Attr0E2Enum = "content";
export type ApiV1StandardsRequirementsCreateContentErrorComponent = {
  attr: Attr0E2Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type Attr5B9Enum = "reference";
export type ApiV1StandardsRequirementsCreateReferenceErrorComponent = {
  attr: Attr5B9Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type Attr9C9Enum = "section";
export type ApiV1StandardsRequirementsCreateSectionErrorComponent = {
  attr: Attr9C9Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type Attr662Enum = "section_ref";
export type ApiV1StandardsRequirementsCreateSectionRefErrorComponent = {
  attr: Attr662Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type Attr977Enum = "sub_section";
export type Code066Enum = "invalid" | "null_characters_not_allowed" | "required" | "surrogate_characters_not_allowed";
export type ApiV1StandardsRequirementsCreateSubSectionErrorComponent = {
  attr: Attr977Enum;
  code: Code066Enum;
  detail: string;
};
export type Attr1B9Enum = "sub_section_ref";
export type ApiV1StandardsRequirementsCreateSubSectionRefErrorComponent = {
  attr: Attr1B9Enum;
  code: Code066Enum;
  detail: string;
};
export type Attr9DaEnum = "standard";
export type ApiV1StandardsRequirementsCreateStandardErrorComponent = {
  attr: Attr9DaEnum;
  code: Code6C0Enum;
  detail: string;
};
export type Attr4A3Enum = "standards_guidance";
export type ApiV1StandardsRequirementsCreateStandardsGuidanceErrorComponent = {
  attr: Attr4A3Enum;
  code: Code633Enum;
  detail: string;
};
export type Attr5EdEnum = "critical";
export type ApiV1StandardsRequirementsCreateCriticalErrorComponent = {
  attr: Attr5EdEnum;
  code: CodeF7EEnum;
  detail: string;
};
export type ApiV1StandardsRequirementsCreateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1StandardsRequirementsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: "content";
    } & ApiV1StandardsRequirementsCreateContentErrorComponent)
  | ({
      attr: "reference";
    } & ApiV1StandardsRequirementsCreateReferenceErrorComponent)
  | ({
      attr: "section";
    } & ApiV1StandardsRequirementsCreateSectionErrorComponent)
  | ({
      attr: "section_ref";
    } & ApiV1StandardsRequirementsCreateSectionRefErrorComponent)
  | ({
      attr: "sub_section";
    } & ApiV1StandardsRequirementsCreateSubSectionErrorComponent)
  | ({
      attr: "sub_section_ref";
    } & ApiV1StandardsRequirementsCreateSubSectionRefErrorComponent)
  | ({
      attr: "standard";
    } & ApiV1StandardsRequirementsCreateStandardErrorComponent)
  | ({
      attr: "standards_guidance";
    } & ApiV1StandardsRequirementsCreateStandardsGuidanceErrorComponent)
  | ({
      attr: "critical";
    } & ApiV1StandardsRequirementsCreateCriticalErrorComponent);
export type ApiV1StandardsRequirementsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1StandardsRequirementsCreateError[];
};
export type ApiV1StandardsRequirementsCreateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1StandardsRequirementsCreateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type RequirementWrite = {
  /** Is covered with model translations. */
  content: string;
  reference: string;
  section: string;
  section_ref: string;
  sub_section: string | null;
  sub_section_ref: string | null;
  standard: number;
  standards_guidance: number[];
  critical: boolean;
};
export type RequirementWriteRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  section: string;
  section_ref: string;
  sub_section: string | null;
  sub_section_ref: string | null;
  standard: number;
  standards_guidance: number[];
  critical: boolean;
};
export type ApiV1StandardsRequirementsUpdateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code381Enum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateContentErrorComponent = {
  attr: Attr0E2Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateReferenceErrorComponent = {
  attr: Attr5B9Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateSectionErrorComponent = {
  attr: Attr9C9Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateSectionRefErrorComponent = {
  attr: Attr662Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateSubSectionErrorComponent = {
  attr: Attr977Enum;
  code: Code066Enum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateSubSectionRefErrorComponent = {
  attr: Attr1B9Enum;
  code: Code066Enum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateStandardErrorComponent = {
  attr: Attr9DaEnum;
  code: Code6C0Enum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateStandardsGuidanceErrorComponent = {
  attr: Attr4A3Enum;
  code: Code633Enum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateCriticalErrorComponent = {
  attr: Attr5EdEnum;
  code: CodeF7EEnum;
  detail: string;
};
export type ApiV1StandardsRequirementsUpdateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1StandardsRequirementsUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: "content";
    } & ApiV1StandardsRequirementsUpdateContentErrorComponent)
  | ({
      attr: "reference";
    } & ApiV1StandardsRequirementsUpdateReferenceErrorComponent)
  | ({
      attr: "section";
    } & ApiV1StandardsRequirementsUpdateSectionErrorComponent)
  | ({
      attr: "section_ref";
    } & ApiV1StandardsRequirementsUpdateSectionRefErrorComponent)
  | ({
      attr: "sub_section";
    } & ApiV1StandardsRequirementsUpdateSubSectionErrorComponent)
  | ({
      attr: "sub_section_ref";
    } & ApiV1StandardsRequirementsUpdateSubSectionRefErrorComponent)
  | ({
      attr: "standard";
    } & ApiV1StandardsRequirementsUpdateStandardErrorComponent)
  | ({
      attr: "standards_guidance";
    } & ApiV1StandardsRequirementsUpdateStandardsGuidanceErrorComponent)
  | ({
      attr: "critical";
    } & ApiV1StandardsRequirementsUpdateCriticalErrorComponent);
export type ApiV1StandardsRequirementsUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1StandardsRequirementsUpdateError[];
};
export type ApiV1StandardsRequirementsUpdateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1StandardsRequirementsUpdateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type PatchedRequirementWrite = {
  /** Is covered with model translations. */
  content?: string;
  reference?: string;
  section?: string;
  section_ref?: string;
  sub_section?: string | null;
  sub_section_ref?: string | null;
  standard?: number;
  standards_guidance?: number[];
  critical?: boolean;
};
export type PatchedRequirementWriteRead = {
  id?: number;
  /** Is covered with model translations. */
  content?: string;
  reference?: string;
  section?: string;
  section_ref?: string;
  sub_section?: string | null;
  sub_section_ref?: string | null;
  standard?: number;
  standards_guidance?: number[];
  critical?: boolean;
};
export type StandardFilter = {
  name: string;
};
export type StandardFilterRead = {
  id: number;
  name: string;
};
export type RequirementFilters = {
  standards: StandardFilter[];
};
export type RequirementFiltersRead = {
  standards: StandardFilterRead[];
};
export type LinkProtocolQuestion = {
  protocol_questions: number[];
  requirement: number;
};
export type LinkRequirement = {
  protocol_question: number;
  requirements: number[];
};
export type HighlightedRequirementSection = {
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  highlights: RequirementHighlightsSection | null;
};
export type HighlightedRequirementSectionRead = {
  id: number;
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  highlights: RequirementHighlightsSection | null;
};
export type PaginatedHighlightedRequirementSectionList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: HighlightedRequirementSection[];
};
export type PaginatedHighlightedRequirementSectionListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: HighlightedRequirementSectionRead[];
};
export type RequirementLinkingListSimilarityScore = {
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: Standard;
  highlights: RequirementHighlightsSection | null;
};
export type RequirementLinkingListSimilarityScoreRead = {
  id: number;
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
  standard: StandardRead;
  section_ref: string;
  sub_section_ref: string;
  /** Using `first` didn't allow for prefetching for some reason. While `all` and selecting first element
    works nicely. We expect to have only one row for requirement, so it should be safe. */
  section: string;
  sub_section: string;
  questions: RequirementLinkingListPartialQuestionRead[];
  /** The `obj` is not exactly the `Requirement` instance as got additional field - `similarity_score`. */
  similarity_score: number;
  highlights: RequirementHighlightsSection | null;
};
export type StandardGuidanceList = {
  /** Is covered with model translations. */
  content: string;
  type: GuidanceType;
  standard: number;
};
export type StandardGuidanceLinkedRequirement = {
  id: number;
  reference: string;
  name: string;
  standard_id: number;
};
export type StandardGuidanceListRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  type: GuidanceType;
  standard: number;
  linked_requirements: StandardGuidanceLinkedRequirement[];
};
export type StandardGuidance = {
  /** Is covered with model translations. */
  content: string;
  type: GuidanceType;
  standard: number;
};
export type StandardGuidanceRead = {
  id: number;
  /** Is covered with model translations. */
  content: string;
  type: GuidanceType;
  standard: number;
};
export type PatchedStandardGuidance = {
  /** Is covered with model translations. */
  content?: string;
  type?: GuidanceType;
  standard?: number;
};
export type PatchedStandardGuidanceRead = {
  id?: number;
  /** Is covered with model translations. */
  content?: string;
  type?: GuidanceType;
  standard?: number;
};
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code023Enum;
  detail: string;
};
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateStandardGuidancesErrorComponentAttrEnum =
  "standard_guidances";
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateStandardGuidancesErrorComponent = {
  attr: ApiV1StandardsStandardGuidanceLinkToRequirementCreateStandardGuidancesErrorComponentAttrEnum;
  code: Code633Enum;
  detail: string;
};
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateRequirementErrorComponentAttrEnum = "requirement";
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateRequirementErrorComponent = {
  attr: ApiV1StandardsStandardGuidanceLinkToRequirementCreateRequirementErrorComponentAttrEnum;
  code: Code6C0Enum;
  detail: string;
};
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1StandardsStandardGuidanceLinkToRequirementCreateNonFieldErrorsErrorComponent)
  | ({
      attr: "standard_guidances";
    } & ApiV1StandardsStandardGuidanceLinkToRequirementCreateStandardGuidancesErrorComponent)
  | ({
      attr: "requirement";
    } & ApiV1StandardsStandardGuidanceLinkToRequirementCreateRequirementErrorComponent);
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1StandardsStandardGuidanceLinkToRequirementCreateError[];
};
export type ApiV1StandardsStandardGuidanceLinkToRequirementCreateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1StandardsStandardGuidanceLinkToRequirementCreateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type LinkStandardGuidance = {
  standard_guidances: number[];
  requirement: number;
};
export type StandardExtended = {
  body?: string | null;
  name: string;
  full_name: string;
  version: string;
  requirement_corpus_link?: string;
  published_date?: string | null;
};
export type StandardExtendedRead = {
  id: number;
  body?: string | null;
  name: string;
  full_name: string;
  version: string;
  requirement_corpus_link?: string;
  published_date?: string | null;
  tenants: CorporationSimple[];
};
export type ApiV1StandardsStandardsCreateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code381Enum;
  detail: string;
};
export type Attr28AEnum = "body";
export type ApiV1StandardsStandardsCreateBodyErrorComponent = {
  attr: Attr28AEnum;
  code: CodeE4EEnum;
  detail: string;
};
export type ApiV1StandardsStandardsCreateNameErrorComponent = {
  attr: Attr5EbEnum;
  code: CodeA3CEnum;
  detail: string;
};
export type Attr169Enum = "full_name";
export type ApiV1StandardsStandardsCreateFullNameErrorComponent = {
  attr: Attr169Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type AttrBa9Enum = "version";
export type ApiV1StandardsStandardsCreateVersionErrorComponent = {
  attr: AttrBa9Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type Attr59DEnum = "requirement_corpus_link";
export type CodeF87Enum =
  | "invalid"
  | "max_length"
  | "null"
  | "null_characters_not_allowed"
  | "surrogate_characters_not_allowed";
export type ApiV1StandardsStandardsCreateRequirementCorpusLinkErrorComponent = {
  attr: Attr59DEnum;
  code: CodeF87Enum;
  detail: string;
};
export type Attr7C0Enum = "published_date";
export type ApiV1StandardsStandardsCreatePublishedDateErrorComponent = {
  attr: Attr7C0Enum;
  code: CodeCeaEnum;
  detail: string;
};
export type Attr984Enum = "tenants";
export type ApiV1StandardsStandardsCreateTenantsErrorComponent = {
  attr: Attr984Enum;
  code: Code2DeEnum;
  detail: string;
};
export type ApiV1StandardsStandardsCreateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1StandardsStandardsCreateNonFieldErrorsErrorComponent)
  | ({
      attr: "body";
    } & ApiV1StandardsStandardsCreateBodyErrorComponent)
  | ({
      attr: "name";
    } & ApiV1StandardsStandardsCreateNameErrorComponent)
  | ({
      attr: "full_name";
    } & ApiV1StandardsStandardsCreateFullNameErrorComponent)
  | ({
      attr: "version";
    } & ApiV1StandardsStandardsCreateVersionErrorComponent)
  | ({
      attr: "requirement_corpus_link";
    } & ApiV1StandardsStandardsCreateRequirementCorpusLinkErrorComponent)
  | ({
      attr: "published_date";
    } & ApiV1StandardsStandardsCreatePublishedDateErrorComponent)
  | ({
      attr: "tenants";
    } & ApiV1StandardsStandardsCreateTenantsErrorComponent);
export type ApiV1StandardsStandardsCreateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1StandardsStandardsCreateError[];
};
export type ApiV1StandardsStandardsCreateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1StandardsStandardsCreateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type ApiV1StandardsStandardsUpdateNonFieldErrorsErrorComponent = {
  attr: AttrD81Enum;
  code: Code381Enum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdateBodyErrorComponent = {
  attr: Attr28AEnum;
  code: CodeE4EEnum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdateNameErrorComponent = {
  attr: Attr5EbEnum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdateFullNameErrorComponent = {
  attr: Attr169Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdateVersionErrorComponent = {
  attr: AttrBa9Enum;
  code: CodeA3CEnum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdateRequirementCorpusLinkErrorComponent = {
  attr: Attr59DEnum;
  code: CodeF87Enum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdatePublishedDateErrorComponent = {
  attr: Attr7C0Enum;
  code: CodeCeaEnum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdateTenantsErrorComponent = {
  attr: Attr984Enum;
  code: Code2DeEnum;
  detail: string;
};
export type ApiV1StandardsStandardsUpdateError =
  | ({
      attr: "non_field_errors";
    } & ApiV1StandardsStandardsUpdateNonFieldErrorsErrorComponent)
  | ({
      attr: "body";
    } & ApiV1StandardsStandardsUpdateBodyErrorComponent)
  | ({
      attr: "name";
    } & ApiV1StandardsStandardsUpdateNameErrorComponent)
  | ({
      attr: "full_name";
    } & ApiV1StandardsStandardsUpdateFullNameErrorComponent)
  | ({
      attr: "version";
    } & ApiV1StandardsStandardsUpdateVersionErrorComponent)
  | ({
      attr: "requirement_corpus_link";
    } & ApiV1StandardsStandardsUpdateRequirementCorpusLinkErrorComponent)
  | ({
      attr: "published_date";
    } & ApiV1StandardsStandardsUpdatePublishedDateErrorComponent)
  | ({
      attr: "tenants";
    } & ApiV1StandardsStandardsUpdateTenantsErrorComponent);
export type ApiV1StandardsStandardsUpdateValidationError = {
  type: ValidationErrorEnum;
  errors: ApiV1StandardsStandardsUpdateError[];
};
export type ApiV1StandardsStandardsUpdateErrorResponse400 =
  | ({
      type: "validation_error";
    } & ApiV1StandardsStandardsUpdateValidationError)
  | ({
      type: "client_error";
    } & ParseErrorResponse);
export type PatchedStandard = {
  body?: string | null;
  name?: string;
  full_name?: string;
  version?: string;
  requirement_corpus_link?: string;
  published_date?: string | null;
  tenants?: string[];
};
export type PatchedStandardRead = {
  id?: number;
  body?: string | null;
  name?: string;
  full_name?: string;
  version?: string;
  requirement_corpus_link?: string;
  published_date?: string | null;
  tenants?: string[];
};
export type Section = {
  title: string;
  reference: string;
};
export type RequirementSection = {
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
};
export type RequirementSectionRead = {
  id: number;
  full_name: string;
  /** Is covered with model translations. */
  content: string;
  reference: string;
};
export type SectionRead = {
  title: string;
  reference: string;
  id: number;
  requirements: RequirementSectionRead[];
};
export type SectionWithSubSection = {
  title: string;
  reference: string;
  sub_sections: Section[];
  requirements: RequirementSection[];
};
export type SectionWithSubSectionRead = {
  title: string;
  reference: string;
  id: number;
  sub_sections: SectionRead[];
  requirements: RequirementSectionRead[];
};
export type SectionCreate = {
  title: string;
  reference: string;
};
export type StandardsFilter = {
  versions: string[];
  tenants: CorporationSimple[];
};
export type S3Fields = {
  key: string;
  AWSAccessKeyId: string;
  policy: string;
  signature: string;
  "x-amz-security-token": string;
};
export type UploadResponse = {
  url: string;
  fields: S3Fields;
};
export type UserManagement = {
  first_name?: string;
  last_name?: string;
  email: string;
  job_title?: string | null;
  groups: string[];
};
export type UserManagementRead = {
  id: string;
  first_name?: string;
  last_name?: string;
  email: string;
  job_title?: string | null;
  /** Expired invitations after 7 days need to be dynamically counted per request as we have no async/cron jobs,
    to expire change status automatically after 7 days.
    Unfortunately, django, even though SerializerMethodField is read_only, is calling this method on create,
    so we need to check if object type is User to have the invitation_has_expired method. */
  status: string;
  groups: string[];
  /** Unfortunately, django, even though SerializerMethodField is read_only, is calling this method on create,
    so we need to check if object type is User to have the user_status property. */
  user_status: string;
};
export type PaginatedUserManagementList = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: UserManagement[];
};
export type PaginatedUserManagementListRead = {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: UserManagementRead[];
};
export type UserManagementActionSuccess = {
  status: string;
};
export type ApiV1UserManagementResetMfaCreateErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type ApiV1UserManagementResetPasswordCreateErrorResponse400 = {
  type: "client_error";
} & ParseErrorResponse;
export type UserManagementFilters = {
  user_status: string[][];
};
export type UserManagementBase = {
  first_name?: string;
  last_name?: string;
  email: string;
  job_title?: string | null;
  groups: string[];
};
export type UserManagementBaseRead = {
  id: string;
  first_name?: string;
  last_name?: string;
  email: string;
  job_title?: string | null;
  /** Expired invitations after 7 days need to be dynamically counted per request as we have no async/cron jobs,
    to expire change status automatically after 7 days.
    Unfortunately, django, even though SerializerMethodField is read_only, is calling this method on create,
    so we need to check if object type is User to have the invitation_has_expired method. */
  status: string;
  groups: string[];
  /** Unfortunately, django, even though SerializerMethodField is read_only, is calling this method on create,
    so we need to check if object type is User to have the user_status property. */
  user_status: string;
};
export type UserProfile = {
  first_name?: string;
  last_name?: string;
  job_title?: string | null;
};
export type UserPreference = {
  preference: any;
};
export type UserPreferenceRead = {
  table_name: string;
  preference: any;
};
export type WhoAmI = {
  email: string;
  first_name?: string;
  last_name?: string;
  job_title?: string | null;
};
export type WhoAmIRead = {
  id: string;
  email: string;
  tenant_id: string | null;
  first_name?: string;
  last_name?: string;
  job_title?: string | null;
  groups: string[];
  tenant: CorporationSimple | null;
};
export const {
  useApiV1AdminMappingJobsDownloadRetrieveMutation,
  useApiV1AdminMappingJobsProgressRetrieveQuery,
  useApiV1AdminMappingJobsDumpCreateMutation,
  useApiV1AdminMappingJobsLoadCreateMutation,
  useApiV1AdminUserReportRetrieveMutation,
  useApiV1AssessmentsCleanupDestroyMutation,
  useApiV1AssessmentsThemeProgressListQuery,
  useApiV1AssessmentsAssessmentsListQuery,
  useApiV1AssessmentsAssessmentsCreateMutation,
  useApiV1AssessmentsAssessmentsRetrieveQuery,
  useApiV1AssessmentsAssessmentsUpdateMutation,
  useApiV1AssessmentsAssessmentsPartialUpdateMutation,
  useApiV1AssessmentsAssessmentsDestroyMutation,
  useApiV1AssessmentsAssessmentsCommentsListQuery,
  useApiV1AssessmentsAssessmentsCompleteCreateMutation,
  useApiV1AssessmentsAssessmentsFavoriteCreateMutation,
  useApiV1AssessmentsAssessmentsFavoriteDestroyMutation,
  useApiV1AssessmentsAssessmentsProtocolQuestionsListQuery,
  useApiV1AssessmentsAssessmentsProtocolQuestionsTasksListQuery,
  useApiV1AssessmentsAssessmentsReviewAssignmentRetrieveQuery,
  useApiV1AssessmentsAssessmentsReviewAssignmentsCreateMutation,
  useApiV1AssessmentsAssessmentsReviewAssignmentsRetrieveQuery,
  useApiV1AssessmentsAssessmentsReviewAssignmentsUpdateMutation,
  useApiV1AssessmentsAssessmentsReviewAssignmentsDestroyMutation,
  useApiV1AssessmentsAssessmentsReviewAssignmentsAvailableStepsRetrieveQuery,
  useApiV1AssessmentsAssessmentsReviewAssignmentsReviewersRetrieveQuery,
  useApiV1AssessmentsAssessmentsReviewAssignmentsStepsListQuery,
  useApiV1AssessmentsAssessmentsReviewAssignmentsStepsAssignedThemesListQuery,
  useApiV1AssessmentsAssessmentsReviewAssignmentsStepsUnassignedThemesListQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsListQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsRetrieveQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsApprovalRetrieveQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsApprovalCreateMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsAssignCreateMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsAssignedRetrieveQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsCommentsListQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsVerificationRetrieveQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsVerificationCreateMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksListQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksRetrieveQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsListQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsCreateMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsUpdateMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksCommentsDestroyMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksEvidencesUpdateMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksRelatedUsersRetrieveQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromOtherSitesListQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksResponsesFromRelatedQuestionsListQuery,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksReviewCreateMutation,
  useApiV1AssessmentsAssessmentsSiteAssessmentsTasksSavePublishedChangesCreateMutation,
  useApiV1AssessmentsAssessmentsSitesWithStandardsListQuery,
  useApiV1AssessmentsAssessmentsVerifierAssignmentsUpdateMutation,
  useApiV1AssessmentsAssessmentsVerifierAssignmentsDeleteStepDestroyMutation,
  useApiV1AssessmentsAssessmentsVerifierAssignmentsStepDetailsRetrieveQuery,
  useApiV1AssessmentsAssessmentsVerifierAssignmentsVerifiersListQuery,
  useApiV1AssessmentsEvidencesListQuery,
  useApiV1AssessmentsSiteAssessmentsAvailableStandardsListQuery,
  useApiV1AssessmentsSiteAssessmentsAvailableTasksListQuery,
  useApiV1AssessmentsSiteAssessmentsAvailableTasksStandardListQuery,
  useApiV1AssessmentsSitesListQuery,
  useApiV1AssessmentsSitesCreateMutation,
  useApiV1AssessmentsSitesRetrieveQuery,
  useApiV1AssessmentsSitesUpdateMutation,
  useApiV1AssessmentsSitesDestroyMutation,
  useApiV1AssessmentsSitesAllListQuery,
  useApiV1AssessmentsSitesAssignedAssessmentsWithStandardsListQuery,
  useApiV1AssessmentsSitesAssignedAssessmentsWithStandardsFiltersRetrieveQuery,
  useApiV1AssessmentsSitesFiltersRetrieveQuery,
  useApiV1AssessmentsSitesImportCreateMutation,
  useApiV1AssessmentsTasksProgressListQuery,
  useApiV1AssessmentsUpdatePanelAssessmentsRetrieveQuery,
  useApiV1AssessmentsUpdatePanelAssessmentsDryRunRetrieveMutation,
  useApiV1AssessmentsUpdatePanelAssessmentsHistoryRetrieveMutation,
  useApiV1AssessmentsUpdatePanelAssessmentsUpdateCreateMutation,
  useApiV1BiExportListQuery,
  useApiV1ConformityHeatmapDataListQuery,
  useApiV1ConformityHeatmapFiltersDataRetrieveQuery,
  useApiV1CorporationsListQuery,
  useApiV1CorporationsCreateMutation,
  useApiV1CorporationsRetrieveQuery,
  useApiV1CorporationsUpdateMutation,
  useApiV1CorporationsCleanupDestroyMutation,
  useApiV1CorporationsFlagsRetrieveQuery,
  useApiV1CorporationsSimplifyListQuery,
  useApiV1DownloadRetrieveMutation,
  useApiV1DownloadSiteAssessmentsAttachmentsRetrieveQuery,
  useApiV1NotificationsCurrentListQuery,
  useApiV1NotificationsProductCreateMutation,
  useApiV1NotificationsThemeAssignedCreateMutation,
  useApiV1ProtocolSetsListQuery,
  useApiV1ProtocolSetsRetrieveQuery,
  useApiV1ProtocolSetsCleanupDestroyMutation,
  useApiV1ProtocolSetsFiltersRetrieveQuery,
  useApiV1ProtocolSetsInterlinkCreateMutation,
  useApiV1ProtocolSetsProtocolQuestionCreateMutation,
  useApiV1ProtocolSetsProtocolQuestionsListQuery,
  useApiV1ProtocolSetsProtocolQuestionsDownloadMappingXlsxRetrieveMutation,
  useApiV1ProtocolSetsProtocolQuestionsDownloadXlsxRetrieveMutation,
  useApiV1ProtocolSetsProtocolQuestionsSmartSemanticSearchListQuery,
  useApiV1ProtocolSetsPublishCreateMutation,
  useApiV1ProtocolSetsSetToReviewCreateMutation,
  useApiV1ProtocolSetsCompareListMutation,
  useApiV1ProtocolSetsCreateDraftCreateMutation,
  useApiV1ProtocolSetsLatestOrDraftRetrieveQuery,
  useApiV1ReportsAssessmentsSiteAssessmentsListQuery,
  useApiV1ReportsAssessmentsSiteAssessmentsDownloadCsvRetrieveMutation,
  useApiV1ReportsAssessmentsSiteAssessmentsDownloadXlsxRetrieveMutation,
  useApiV1ReportsAssessmentsSiteAssessmentsFiltersRetrieveQuery,
  useApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaRetrieveQuery,
  useApiV1ReportsAssessmentsSiteAssessmentsStandardsIrmaXlsxRetrieveMutation,
  useApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupListQuery,
  useApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadCsvRetrieveMutation,
  useApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupDownloadXlsxRetrieveMutation,
  useApiV1ReportsAssessmentsSiteAssessmentsStandardsRollupFiltersRetrieveQuery,
  useApiV1ReportsCustomListQuery,
  useApiV1ReportsCustomCreateMutation,
  useApiV1ReportsCustomRetrieveQuery,
  useApiV1ReportsCustomPartialUpdateMutation,
  useApiV1ReportsCustomDestroyMutation,
  useApiV1ReportsCustomDownloadCsvRetrieveMutation,
  useApiV1ReportsCustomDownloadXlsxRetrieveMutation,
  useApiV1CustomReportFiltersDetailQuery,
  useApiV1ReportsCustomGetDataRetrieveQuery,
  useApiV1ReportsCustomFiltersRetrieveQuery,
  useApiV1ScopesOfApplicabilityListQuery,
  useApiV1StandardsProtocolsRetrieveQuery,
  useApiV1StandardsProtocolsUpdateMutation,
  useApiV1StandardsProtocolsPartialUpdateMutation,
  useApiV1StandardsProtocolsDestroyMutation,
  useApiV1StandardsProtocolsDuplicateCreateMutation,
  useApiV1StandardsProtocolsRelatedProtocolsListQuery,
  useApiV1StandardsProtocolsRelatedProtocolsCreateMutation,
  useApiV1StandardsProtocolsRelatedProtocolsDestroyMutation,
  useApiV1StandardsProtocolsShowHistoryListQuery,
  useApiV1StandardsProtocolsReorderCreateMutation,
  useApiV1StandardsRequirementsListQuery,
  useApiV1StandardsRequirementsCreateMutation,
  useApiV1StandardsRequirementsRetrieveQuery,
  useApiV1StandardsRequirementsUpdateMutation,
  useApiV1StandardsRequirementsPartialUpdateMutation,
  useApiV1StandardsRequirementsDestroyMutation,
  useApiV1StandardsRequirementsFiltersRetrieveQuery,
  useApiV1StandardsRequirementsLinkProtocolQuestionsCreateMutation,
  useApiV1StandardsRequirementsLinkToProtocolQuestionCreateMutation,
  useApiV1StandardsRequirementsLiteListQuery,
  useApiV1StandardsRequirementsSmartSemanticSearchListQuery,
  useApiV1StandardsRequirementsUnlinkFromProtocolQuestionCreateMutation,
  useApiV1StandardsStandardGuidanceListQuery,
  useApiV1StandardsStandardGuidanceCreateMutation,
  useApiV1StandardsStandardGuidanceRetrieveQuery,
  useApiV1StandardsStandardGuidanceUpdateMutation,
  useApiV1StandardsStandardGuidancePartialUpdateMutation,
  useApiV1StandardsStandardGuidanceDestroyMutation,
  useApiV1StandardsStandardGuidanceLinkToRequirementCreateMutation,
  useApiV1StandardsStandardGuidanceUnlinkFromRequirementCreateMutation,
  useApiV1StandardsStandardsListQuery,
  useApiV1StandardsStandardsCreateMutation,
  useApiV1StandardsStandardsRetrieveQuery,
  useApiV1StandardsStandardsUpdateMutation,
  useApiV1StandardsStandardsPartialUpdateMutation,
  useApiV1StandardsStandardsDestroyMutation,
  useApiV1StandardsStandardsSectionsListQuery,
  useApiV1StandardsStandardsSectionsCreateMutation,
  useApiV1StandardsStandardsSectionsCreate2Mutation,
  useApiV1StandardsStandardsSectionsUpdateMutation,
  useApiV1StandardsStandardsSectionsDestroyMutation,
  useApiV1StandardsStandardsFiltersRetrieveQuery,
  useApiV1StandardsSubthemesListQuery,
  useApiV1StandardsThemesListQuery,
  useApiV1UploadRetrieveMutation,
  useApiV1UserManagementListQuery,
  useApiV1UserManagementCreateMutation,
  useApiV1UserManagementRetrieveQuery,
  useApiV1UserManagementUpdateMutation,
  useApiV1UserManagementDestroyMutation,
  useApiV1UserManagementDeactivateCreateMutation,
  useApiV1UserManagementReactivateCreateMutation,
  useApiV1UserManagementReinviteCreateMutation,
  useApiV1UserManagementResetMfaCreateMutation,
  useApiV1UserManagementResetPasswordCreateMutation,
  useApiV1UserManagementFiltersRetrieveQuery,
  useApiV1UserManagementInviteAdminCreateMutation,
  useApiV1UserManagementProfileUpdateMutation,
  useApiV1UserPreferencesListQuery,
  useApiV1UserPreferencesRetrieveQuery,
  useApiV1UserPreferencesUpdateMutation,
  useApiV1UsersListQuery,
  useWhoamiRetrieveQuery,
} = injectedRtkApi;
